/* tslint:disable */
/* eslint-disable */
/**
 * CO2AI Ecosystem API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountCreateRequest
 */
export interface AccountCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    accessManagementToken?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    organisationName: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    organisationCity: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    organisationCountry: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    userFullName: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    userJobTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCreateRequest
     */
    userPassword?: string;
}
/**
 * 
 * @export
 * @interface AggregatedProductRequestAgeResponse
 */
export interface AggregatedProductRequestAgeResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregatedProductRequestAgeResponse
     */
    tenDays: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedProductRequestAgeResponse
     */
    thirtyDays: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedProductRequestAgeResponse
     */
    sixtyDays: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedProductRequestAgeResponse
     */
    ninetyDays: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedProductRequestAgeResponse
     */
    moreThanNinetyDays: number;
}
/**
 * 
 * @export
 * @interface AggregatedProductRequestDataResponse
 */
export interface AggregatedProductRequestDataResponse {
    /**
     * 
     * @type {ProductRequestOverview}
     * @memberof AggregatedProductRequestDataResponse
     */
    received: ProductRequestOverview;
    /**
     * 
     * @type {ProductRequestOverview}
     * @memberof AggregatedProductRequestDataResponse
     */
    sent: ProductRequestOverview;
}
/**
 * 
 * @export
 * @interface AggregatedRequestDataResponse
 */
export interface AggregatedRequestDataResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    sentRequestsAnswered: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    sentRequestsRejected: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    sentRequestsResubmitted: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    totalSentRequests: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    receivedRequestsAnswered: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    receivedRequestsRejected: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    receivedRequestsResubmitted: number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedRequestDataResponse
     */
    totalReceivedRequests: number;
}
/**
 * 
 * @export
 * @interface AttachmentInfo
 */
export interface AttachmentInfo {
    /**
     * 
     * @type {string}
     * @memberof AttachmentInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentInfo
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentInfo
     */
    isUsed: boolean;
}
/**
 * 
 * @export
 * @interface AttachmentListMetadataResponse
 */
export interface AttachmentListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof AttachmentListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof AttachmentListMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof AttachmentListMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface AttachmentListResponse
 */
export interface AttachmentListResponse {
    /**
     * 
     * @type {ReadonlyArray<AttachmentInfo>}
     * @memberof AttachmentListResponse
     */
    data: ReadonlyArray<AttachmentInfo>;
    /**
     * 
     * @type {AttachmentListMetadataResponse}
     * @memberof AttachmentListResponse
     */
    metadata: AttachmentListMetadataResponse;
}
/**
 * 
 * @export
 * @interface AttachmentsDeleteRequest
 */
export interface AttachmentsDeleteRequest {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof AttachmentsDeleteRequest
     */
    ids: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface AttachmentsDeleteResponse
 */
export interface AttachmentsDeleteResponse {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof AttachmentsDeleteResponse
     */
    ids: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface CarbonFootprint
 */
export interface CarbonFootprint {
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    declaredUnit: CarbonFootprintDeclaredUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    unitaryProductAmount: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    pCfExcludingBiogenic: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    pCfIncludingBiogenic?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    fossilGhgEmissions: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    fossilCarbonContent: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    biogenicCarbonContent: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    dLucGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    landManagementGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    otherBiogenicGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    iLucGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    biogenicCarbonWithdrawal?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    aircraftGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    characterizationFactors: CarbonFootprintCharacterizationFactorsEnum;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof CarbonFootprint
     */
    crossSectoralStandardsUsed: ReadonlyArray<CarbonFootprintCrossSectoralStandardsUsedEnum>;
    /**
     * 
     * @type {object}
     * @memberof CarbonFootprint
     */
    productOrSectorSpecificRules?: object;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    biogenicAccountingMethodology?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    boundaryProcessesDescription: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    referencePeriodStart: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    referencePeriodEnd: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    geographyCountrySubdivision?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    geographyCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    regionOrSubregion?: string;
    /**
     * 
     * @type {ReadonlyArray<EmissionFactorDS>}
     * @memberof CarbonFootprint
     */
    secondaryEmissionFactorSources?: ReadonlyArray<EmissionFactorDS>;
    /**
     * 
     * @type {number}
     * @memberof CarbonFootprint
     */
    exemptedEmissionsPercent: number;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    exemptedEmissionsDescription: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarbonFootprint
     */
    packagingEmissionsIncluded: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    packagingGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    allocationRulesDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    uncertaintyAssessmentDescription?: string;
    /**
     * 
     * @type {number}
     * @memberof CarbonFootprint
     */
    primaryDataShare?: number;
    /**
     * 
     * @type {object}
     * @memberof CarbonFootprint
     */
    dqi?: object;
    /**
     * 
     * @type {object}
     * @memberof CarbonFootprint
     */
    assurance?: object;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    pcfExcludingBiogenic: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    pcfIncludingBiogenic?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    dlucGhgEmissions?: string;
    /**
     * 
     * @type {string}
     * @memberof CarbonFootprint
     */
    ilucGhgEmissions?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CarbonFootprintDeclaredUnitEnum {
    LITER = 'liter',
    KILOGRAM = 'kilogram',
    CUBIC_METER = 'cubic meter',
    KILOWATT_HOUR = 'kilowatt hour',
    MEGAJOULE = 'megajoule',
    TON_KILOMETER = 'ton kilometer',
    SQUARE_METER = 'square meter'
}
/**
    * @export
    * @enum {string}
    */
export enum CarbonFootprintCharacterizationFactorsEnum {
    AR6 = 'AR6',
    AR5 = 'AR5'
}
/**
    * @export
    * @enum {string}
    */
export enum CarbonFootprintCrossSectoralStandardsUsedEnum {
    GHG_PROTOCOL_PRODUCT_STANDARD = 'GHG Protocol Product standard',
    ISO_STANDARD_14067 = 'ISO Standard 14067',
    ISO_STANDARD_14044 = 'ISO Standard 14044'
}

/**
 * 
 * @export
 * @interface CompanyExistsRequest
 */
export interface CompanyExistsRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyExistsRequest
     */
    email: string;
}
/**
 * 
 * @export
 * @interface CompanyExistsResponse
 */
export interface CompanyExistsResponse {
    /**
     * 
     * @type {string}
     * @memberof CompanyExistsResponse
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyExistsResponse
     */
    domainExists: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyExistsResponse
     */
    userAlreadyExists: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyExistsResponse
     */
    domainWhitelisted: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyExistsResponse
     */
    userActivationStatus?: CompanyExistsResponseUserActivationStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CompanyExistsResponseUserActivationStatusEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    WAITING_FOR_COMPLETION = 'WAITING_FOR_COMPLETION'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConfidenceLevel {
    VERY = 'VERY',
    SOMEWHAT = 'SOMEWHAT',
    NONE = 'NONE'
}

/**
 * 
 * @export
 * @interface CorpoEmissionProductListResponse
 */
export interface CorpoEmissionProductListResponse {
    /**
     * 
     * @type {CorpoProductListMetadataResponse}
     * @memberof CorpoEmissionProductListResponse
     */
    metadata: CorpoProductListMetadataResponse;
    /**
     * 
     * @type {ReadonlyArray<CorpoEmissionProductResponse>}
     * @memberof CorpoEmissionProductListResponse
     */
    data: ReadonlyArray<CorpoEmissionProductResponse>;
}
/**
 * 
 * @export
 * @interface CorpoEmissionProductResponse
 */
export interface CorpoEmissionProductResponse {
    /**
     * 
     * @type {string}
     * @memberof CorpoEmissionProductResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CorpoEmissionProductResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CorpoEmissionProductResponse
     */
    internalReference?: string;
    /**
     * 
     * @type {string}
     * @memberof CorpoEmissionProductResponse
     */
    lastUpdated: string;
    /**
     * 
     * @type {number}
     * @memberof CorpoEmissionProductResponse
     */
    emissionFactor?: number;
}
/**
 * 
 * @export
 * @interface CorpoProductListMetadataResponse
 */
export interface CorpoProductListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof CorpoProductListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof CorpoProductListMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof CorpoProductListMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface CorpoSupplierResponse
 */
export interface CorpoSupplierResponse {
    /**
     * 
     * @type {string}
     * @memberof CorpoSupplierResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CorpoSupplierResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CorpoSuppliersMetadataResponse
 */
export interface CorpoSuppliersMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof CorpoSuppliersMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof CorpoSuppliersMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof CorpoSuppliersMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface CorpoSuppliersResponse
 */
export interface CorpoSuppliersResponse {
    /**
     * 
     * @type {CorpoSuppliersMetadataResponse}
     * @memberof CorpoSuppliersResponse
     */
    metadata: CorpoSuppliersMetadataResponse;
    /**
     * 
     * @type {ReadonlyArray<CorpoSupplierResponse>}
     * @memberof CorpoSuppliersResponse
     */
    data: ReadonlyArray<CorpoSupplierResponse>;
}
/**
 * 
 * @export
 * @interface CreateEmissionRequest
 */
export interface CreateEmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmissionRequest
     */
    supplierId: string;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof CreateEmissionRequest
     */
    productIds: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface CreateEmissionRequestsRequest
 */
export interface CreateEmissionRequestsRequest {
    /**
     * 
     * @type {ReadonlyArray<ProductSupplierId>}
     * @memberof CreateEmissionRequestsRequest
     */
    products: ReadonlyArray<ProductSupplierId>;
}
/**
 * 
 * @export
 * @interface CreateInvitationsRequest
 */
export interface CreateInvitationsRequest {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof CreateInvitationsRequest
     */
    emails: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface Customer
 */
export interface Customer {
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    name: string;
}
/**
 * 
 * @export
 * @interface DataSourceDetail
 */
export interface DataSourceDetail {
    /**
     * 
     * @type {string}
     * @memberof DataSourceDetail
     */
    dataSourceType: DataSourceDetailDataSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataSourceDetail
     */
    sourceDescription: DataSourceDetailSourceDescriptionEnum;
    /**
     * 
     * @type {string}
     * @memberof DataSourceDetail
     */
    sourceDescriptionOther?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DataSourceDetailDataSourceTypeEnum {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    BOTH = 'BOTH',
    NONE = 'NONE'
}
/**
    * @export
    * @enum {string}
    */
export enum DataSourceDetailSourceDescriptionEnum {
    SELF = 'SELF',
    SUPPLIER = 'SUPPLIER',
    EPA_GHG_EMISSION_FACTORS_HUB = 'EPA_GHG_EMISSION_FACTORS_HUB',
    DEFRA_CONVERSION_FACTORS = 'DEFRA_CONVERSION_FACTORS',
    ADEME_BASE_CARBONE = 'ADEME_BASE_CARBONE',
    IPCC_EMISSION_FACTORS_DATABASE = 'IPCC_EMISSION_FACTORS_DATABASE',
    ECOMETRICA = 'ECOMETRICA',
    IDEMAT = 'IDEMAT',
    ECOINVENT = 'ECOINVENT',
    AGRIFOOTPRINT = 'AGRIFOOTPRINT',
    GABI = 'GABI',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface DataSources
 */
export interface DataSources {
    /**
     * 
     * @type {string}
     * @memberof DataSources
     */
    dataSourceType: DataSourcesDataSourceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DataSources
     */
    shareOfPrimaryDataInEmissionFactor?: number;
    /**
     * 
     * @type {ReadonlyArray<DataSourceDetail>}
     * @memberof DataSources
     */
    dataSourceDetails: ReadonlyArray<DataSourceDetail>;
}

/**
    * @export
    * @enum {string}
    */
export enum DataSourcesDataSourceTypeEnum {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    BOTH = 'BOTH',
    NONE = 'NONE'
}

/**
 * 
 * @export
 * @interface DraftDataSourceDetail
 */
export interface DraftDataSourceDetail {
    /**
     * 
     * @type {string}
     * @memberof DraftDataSourceDetail
     */
    dataSourceType?: DraftDataSourceDetailDataSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftDataSourceDetail
     */
    sourceDescription?: DraftDataSourceDetailSourceDescriptionEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftDataSourceDetail
     */
    sourceDescriptionOther?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DraftDataSourceDetailDataSourceTypeEnum {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    BOTH = 'BOTH',
    NONE = 'NONE'
}
/**
    * @export
    * @enum {string}
    */
export enum DraftDataSourceDetailSourceDescriptionEnum {
    SELF = 'SELF',
    SUPPLIER = 'SUPPLIER',
    EPA_GHG_EMISSION_FACTORS_HUB = 'EPA_GHG_EMISSION_FACTORS_HUB',
    DEFRA_CONVERSION_FACTORS = 'DEFRA_CONVERSION_FACTORS',
    ADEME_BASE_CARBONE = 'ADEME_BASE_CARBONE',
    IPCC_EMISSION_FACTORS_DATABASE = 'IPCC_EMISSION_FACTORS_DATABASE',
    ECOMETRICA = 'ECOMETRICA',
    IDEMAT = 'IDEMAT',
    ECOINVENT = 'ECOINVENT',
    AGRIFOOTPRINT = 'AGRIFOOTPRINT',
    GABI = 'GABI',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface DraftDataSources
 */
export interface DraftDataSources {
    /**
     * 
     * @type {string}
     * @memberof DraftDataSources
     */
    dataSourceType?: DraftDataSourcesDataSourceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DraftDataSources
     */
    shareOfPrimaryDataInEmissionFactor?: number;
    /**
     * 
     * @type {ReadonlyArray<DraftDataSourceDetail>}
     * @memberof DraftDataSources
     */
    dataSourceDetails?: ReadonlyArray<DraftDataSourceDetail>;
}

/**
    * @export
    * @enum {string}
    */
export enum DraftDataSourcesDataSourceTypeEnum {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    BOTH = 'BOTH',
    NONE = 'NONE'
}

/**
 * 
 * @export
 * @interface DraftEmissionRequestFormData
 */
export interface DraftEmissionRequestFormData {
    /**
     * 
     * @type {DraftEmissionValues}
     * @memberof DraftEmissionRequestFormData
     */
    emissionValues?: DraftEmissionValues;
    /**
     * 
     * @type {DraftDataSources}
     * @memberof DraftEmissionRequestFormData
     */
    dataSources?: DraftDataSources;
    /**
     * 
     * @type {DraftMethodologies}
     * @memberof DraftEmissionRequestFormData
     */
    methodologies?: DraftMethodologies;
    /**
     * 
     * @type {DraftVerificationData}
     * @memberof DraftEmissionRequestFormData
     */
    verificationData?: DraftVerificationData;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionRequestFormData
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface DraftEmissionValueItem
 */
export interface DraftEmissionValueItem {
    /**
     * 
     * @type {LifecycleStage}
     * @memberof DraftEmissionValueItem
     */
    lifecycleStage?: LifecycleStage;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionValueItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftEmissionValueItem
     */
    value?: number;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof DraftEmissionValueItem
     */
    unit?: EmissionValueUnit;
    /**
     * 
     * @type {EmissionType}
     * @memberof DraftEmissionValueItem
     */
    emissionType?: EmissionType;
}
/**
 * 
 * @export
 * @interface DraftEmissionValues
 */
export interface DraftEmissionValues {
    /**
     * 
     * @type {boolean}
     * @memberof DraftEmissionValues
     */
    hasEmissionAlreadyAvailable?: boolean;
    /**
     * 
     * @type {EmissionValueGranularityLevel}
     * @memberof DraftEmissionValues
     */
    emissionValuesGranularity?: EmissionValueGranularityLevel;
    /**
     * 
     * @type {DraftEmissionValuesLocation}
     * @memberof DraftEmissionValues
     */
    emissionValuesLocation?: DraftEmissionValuesLocation;
    /**
     * 
     * @type {DraftEmissionsValuesBreakdown}
     * @memberof DraftEmissionValues
     */
    emissionsValuesBreakdown?: DraftEmissionsValuesBreakdown;
    /**
     * 
     * @type {ConfidenceLevel}
     * @memberof DraftEmissionValues
     */
    confidence?: ConfidenceLevel;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionValues
     */
    additionalInformation?: string;
}
/**
 * 
 * @export
 * @interface DraftEmissionValuesLocation
 */
export interface DraftEmissionValuesLocation {
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionValuesLocation
     */
    locationType?: DraftEmissionValuesLocationLocationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionValuesLocation
     */
    region?: DraftEmissionValuesLocationRegionEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionValuesLocation
     */
    country?: DraftEmissionValuesLocationCountryEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DraftEmissionValuesLocationLocationTypeEnum {
    GLOBAL = 'GLOBAL',
    REGIONAL = 'REGIONAL',
    COUNTRY = 'COUNTRY'
}
/**
    * @export
    * @enum {string}
    */
export enum DraftEmissionValuesLocationRegionEnum {
    AFRICA = 'AFRICA',
    ANTARCTICA = 'ANTARCTICA',
    ASIA = 'ASIA',
    EUROPE = 'EUROPE',
    NORTH_AMERICA = 'NORTH_AMERICA',
    OCEANIA = 'OCEANIA',
    SOUTH_AMERICA = 'SOUTH_AMERICA'
}
/**
    * @export
    * @enum {string}
    */
export enum DraftEmissionValuesLocationCountryEnum {
    AFG = 'AFG',
    AGO = 'AGO',
    ALB = 'ALB',
    ARE = 'ARE',
    ARG = 'ARG',
    ARM = 'ARM',
    ATA = 'ATA',
    AUS = 'AUS',
    AUT = 'AUT',
    AZE = 'AZE',
    BDI = 'BDI',
    BEL = 'BEL',
    BEN = 'BEN',
    BFA = 'BFA',
    BGD = 'BGD',
    BGR = 'BGR',
    BHS = 'BHS',
    BIH = 'BIH',
    BLR = 'BLR',
    BLZ = 'BLZ',
    BOL = 'BOL',
    BRA = 'BRA',
    BRN = 'BRN',
    BTN = 'BTN',
    BWA = 'BWA',
    CAF = 'CAF',
    CAN = 'CAN',
    CHE = 'CHE',
    CHL = 'CHL',
    CHN = 'CHN',
    CIV = 'CIV',
    CMR = 'CMR',
    COD = 'COD',
    COG = 'COG',
    COL = 'COL',
    CRI = 'CRI',
    CUB = 'CUB',
    CYP = 'CYP',
    CZE = 'CZE',
    DEU = 'DEU',
    DJI = 'DJI',
    DNK = 'DNK',
    DOM = 'DOM',
    DZA = 'DZA',
    ECU = 'ECU',
    EGY = 'EGY',
    ERI = 'ERI',
    ESP = 'ESP',
    EST = 'EST',
    ETH = 'ETH',
    FIN = 'FIN',
    FJI = 'FJI',
    FLK = 'FLK',
    FRA = 'FRA',
    GAB = 'GAB',
    GBR = 'GBR',
    GEO = 'GEO',
    GHA = 'GHA',
    GIN = 'GIN',
    GMB = 'GMB',
    GNB = 'GNB',
    GNQ = 'GNQ',
    GRC = 'GRC',
    GRL = 'GRL',
    GTM = 'GTM',
    GUY = 'GUY',
    HND = 'HND',
    HRV = 'HRV',
    HTI = 'HTI',
    HUN = 'HUN',
    IDN = 'IDN',
    IND = 'IND',
    IRL = 'IRL',
    IRN = 'IRN',
    IRQ = 'IRQ',
    ISL = 'ISL',
    ISR = 'ISR',
    ITA = 'ITA',
    JAM = 'JAM',
    JOR = 'JOR',
    JPN = 'JPN',
    KAZ = 'KAZ',
    KEN = 'KEN',
    KGZ = 'KGZ',
    KHM = 'KHM',
    KOR = 'KOR',
    KWT = 'KWT',
    LAO = 'LAO',
    LBN = 'LBN',
    LBR = 'LBR',
    LBY = 'LBY',
    LKA = 'LKA',
    LSO = 'LSO',
    LTU = 'LTU',
    LUX = 'LUX',
    LVA = 'LVA',
    MAR = 'MAR',
    MDA = 'MDA',
    MDG = 'MDG',
    MEX = 'MEX',
    MKD = 'MKD',
    MLI = 'MLI',
    MMR = 'MMR',
    MNE = 'MNE',
    MNG = 'MNG',
    MOZ = 'MOZ',
    MRT = 'MRT',
    MWI = 'MWI',
    MYS = 'MYS',
    NAM = 'NAM',
    NCL = 'NCL',
    NER = 'NER',
    NGA = 'NGA',
    NIC = 'NIC',
    NLD = 'NLD',
    NOR = 'NOR',
    NPL = 'NPL',
    NZL = 'NZL',
    OMN = 'OMN',
    PAK = 'PAK',
    PAN = 'PAN',
    PER = 'PER',
    PHL = 'PHL',
    PNG = 'PNG',
    POL = 'POL',
    PRI = 'PRI',
    PRK = 'PRK',
    PRT = 'PRT',
    PRY = 'PRY',
    PSE = 'PSE',
    QAT = 'QAT',
    ROU = 'ROU',
    RUS = 'RUS',
    RWA = 'RWA',
    ESH = 'ESH',
    SAU = 'SAU',
    SDN = 'SDN',
    SSD = 'SSD',
    SEN = 'SEN',
    SLB = 'SLB',
    SLE = 'SLE',
    SLV = 'SLV',
    SOM = 'SOM',
    SRB = 'SRB',
    SUR = 'SUR',
    SVK = 'SVK',
    SVN = 'SVN',
    SWE = 'SWE',
    SWZ = 'SWZ',
    SYR = 'SYR',
    TCD = 'TCD',
    TGO = 'TGO',
    THA = 'THA',
    TJK = 'TJK',
    TKM = 'TKM',
    TLS = 'TLS',
    TTO = 'TTO',
    TUN = 'TUN',
    TUR = 'TUR',
    TWN = 'TWN',
    TZA = 'TZA',
    UGA = 'UGA',
    UKR = 'UKR',
    URY = 'URY',
    USA = 'USA',
    UZB = 'UZB',
    VEN = 'VEN',
    VNM = 'VNM',
    VUT = 'VUT',
    YEM = 'YEM',
    ZAF = 'ZAF',
    ZMB = 'ZMB',
    ZWE = 'ZWE'
}

/**
 * 
 * @export
 * @interface DraftEmissionsValuesBreakdown
 */
export interface DraftEmissionsValuesBreakdown {
    /**
     * 
     * @type {ReadonlyArray<DraftEmissionValueItem>}
     * @memberof DraftEmissionsValuesBreakdown
     */
    materialAcquisitionAndPreprocessing?: ReadonlyArray<DraftEmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<DraftEmissionValueItem>}
     * @memberof DraftEmissionsValuesBreakdown
     */
    production?: ReadonlyArray<DraftEmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<DraftEmissionValueItem>}
     * @memberof DraftEmissionsValuesBreakdown
     */
    distributionAndStorage?: ReadonlyArray<DraftEmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<DraftEmissionValueItem>}
     * @memberof DraftEmissionsValuesBreakdown
     */
    productUse?: ReadonlyArray<DraftEmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<DraftEmissionValueItem>}
     * @memberof DraftEmissionsValuesBreakdown
     */
    endOfLife?: ReadonlyArray<DraftEmissionValueItem>;
    /**
     * 
     * @type {number}
     * @memberof DraftEmissionsValuesBreakdown
     */
    value?: number;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof DraftEmissionsValuesBreakdown
     */
    unit?: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionsValuesBreakdown
     */
    unitOther?: string;
    /**
     * 
     * @type {EmissionValueDataUsed}
     * @memberof DraftEmissionsValuesBreakdown
     */
    dataUsed?: EmissionValueDataUsed;
    /**
     * 
     * @type {string}
     * @memberof DraftEmissionsValuesBreakdown
     */
    additionalComment?: string;
}
/**
 * 
 * @export
 * @interface DraftMethodologies
 */
export interface DraftMethodologies {
    /**
     * 
     * @type {DraftMethodologyStandards}
     * @memberof DraftMethodologies
     */
    methodologyStandards?: DraftMethodologyStandards;
    /**
     * 
     * @type {string}
     * @memberof DraftMethodologies
     */
    collectionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMethodologies
     */
    collectionEndDate?: string;
}
/**
 * 
 * @export
 * @interface DraftMethodologyStandards
 */
export interface DraftMethodologyStandards {
    /**
     * 
     * @type {string}
     * @memberof DraftMethodologyStandards
     */
    standardCompliant?: DraftMethodologyStandardsStandardCompliantEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftMethodologyStandards
     */
    standardUsed?: DraftMethodologyStandardsStandardUsedEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftMethodologyStandards
     */
    additionalInformation?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DraftMethodologyStandardsStandardCompliantEnum {
    YES = 'YES',
    NO = 'NO',
    UNKNOWN = 'UNKNOWN'
}
/**
    * @export
    * @enum {string}
    */
export enum DraftMethodologyStandardsStandardUsedEnum {
    ISO_3459 = 'ISO_3459',
    ISO_14040 = 'ISO_14040',
    ISO_14044 = 'ISO_14044',
    ISO_14067 = 'ISO_14067',
    PAS_2050 = 'PAS_2050',
    PRODUCT_ENVIRONMENTAL_FOOTPRINT = 'PRODUCT_ENVIRONMENTAL_FOOTPRINT',
    BP_X30_323_0 = 'BP_X30_323_0',
    EN_15804 = 'EN_15804',
    EPD_PRODUCT_CATEGORY_RULES = 'EPD_PRODUCT_CATEGORY_RULES',
    CALCULATOR = 'CALCULATOR',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface DraftVerificationAttachment
 */
export interface DraftVerificationAttachment {
    /**
     * 
     * @type {string}
     * @memberof DraftVerificationAttachment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftVerificationAttachment
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface DraftVerificationData
 */
export interface DraftVerificationData {
    /**
     * 
     * @type {boolean}
     * @memberof DraftVerificationData
     */
    isDataVerified?: boolean;
    /**
     * 
     * @type {VerificationProvider}
     * @memberof DraftVerificationData
     */
    verificationProvider?: VerificationProvider;
    /**
     * 
     * @type {VerificationStandard}
     * @memberof DraftVerificationData
     */
    verificationStandard?: VerificationStandard;
    /**
     * 
     * @type {string}
     * @memberof DraftVerificationData
     */
    additionalVerificationProviderDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftVerificationData
     */
    additionalVerificationStandardDetails?: string;
    /**
     * 
     * @type {ReadonlyArray<DraftVerificationAttachment>}
     * @memberof DraftVerificationData
     */
    verificationAttachments?: ReadonlyArray<DraftVerificationAttachment>;
}
/**
 * 
 * @export
 * @interface EmailListRequest
 */
export interface EmailListRequest {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof EmailListRequest
     */
    emails: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface EmailToken
 */
export interface EmailToken {
    /**
     * 
     * @type {string}
     * @memberof EmailToken
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailToken
     */
    recipientEmail: string;
    /**
     * 
     * @type {string}
     * @memberof EmailToken
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof EmailToken
     */
    senderEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailToken
     */
    organisationId?: string;
}
/**
 * 
 * @export
 * @interface EmailTokensResponse
 */
export interface EmailTokensResponse {
    /**
     * 
     * @type {ReadonlyArray<EmailToken>}
     * @memberof EmailTokensResponse
     */
    emailTokens: ReadonlyArray<EmailToken>;
}
/**
 * 
 * @export
 * @interface EmissionDataRejectionRequest
 */
export interface EmissionDataRejectionRequest {
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRejectionRequest
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface EmissionDataRequest
 */
export interface EmissionDataRequest {
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    emissionRequestReference?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    statusLabel?: EmissionDataRequestStatusLabelEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    status: EmissionDataRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    lastUpdated?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    levelOfConfidence?: EmissionDataRequestLevelOfConfidenceEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionDataRequest
     */
    emissionGranularity?: EmissionDataRequestEmissionGranularityEnum;
    /**
     * 
     * @type {number}
     * @memberof EmissionDataRequest
     */
    emissionValue?: number;
    /**
     * 
     * @type {EmissionValuesLocation}
     * @memberof EmissionDataRequest
     */
    emissionValuesLocation?: EmissionValuesLocation;
    /**
     * 
     * @type {boolean}
     * @memberof EmissionDataRequest
     */
    inProgress: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmissionDataRequest
     */
    isLocked: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum EmissionDataRequestStatusLabelEnum {
    OPEN = 'OPEN',
    DECLINED = 'DECLINED',
    IN_REVIEW = 'IN_REVIEW',
    COMPLETE = 'COMPLETE',
    CANCELED = 'CANCELED'
}
/**
    * @export
    * @enum {string}
    */
export enum EmissionDataRequestStatusEnum {
    NOT_STARTED = 'NOT_STARTED',
    REJECTED = 'REJECTED',
    REQUESTED = 'REQUESTED',
    PENDING_REVIEW = 'PENDING_REVIEW',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED'
}
/**
    * @export
    * @enum {string}
    */
export enum EmissionDataRequestLevelOfConfidenceEnum {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW'
}
/**
    * @export
    * @enum {string}
    */
export enum EmissionDataRequestEmissionGranularityEnum {
    DETAILED_LIFECYCLE = 'DETAILED_LIFECYCLE',
    LIFECYCLE = 'LIFECYCLE',
    PRODUCT = 'PRODUCT',
    CALCULATOR = 'CALCULATOR',
    SHARE_COMPANY = 'SHARE_COMPANY',
    UNAVAILABLE = 'UNAVAILABLE'
}

/**
 * 
 * @export
 * @interface EmissionFactorDS
 */
export interface EmissionFactorDS {
    /**
     * 
     * @type {string}
     * @memberof EmissionFactorDS
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionFactorDS
     */
    version: string;
}
/**
 * 
 * @export
 * @interface EmissionRequestAttachmentData
 */
export interface EmissionRequestAttachmentData {
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestAttachmentData
     */
    attachmentId: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestAttachmentData
     */
    data: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestAttachmentData
     */
    mediaType: string;
}
/**
 * 
 * @export
 * @interface EmissionRequestProduct
 */
export interface EmissionRequestProduct {
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    emissionRequestId: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    productDescription?: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof EmissionRequestProduct
     */
    productUnit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    productInternalReference?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    productRequestComment?: string;
    /**
     * 
     * @type {EmissionRequestProductFormData}
     * @memberof EmissionRequestProduct
     */
    emissionData?: EmissionRequestProductFormData;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    productRequestStatus: EmissionRequestProductProductRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    reason: string;
    /**
     * 
     * @type {DraftEmissionRequestFormData}
     * @memberof EmissionRequestProduct
     */
    emissionDraftData?: DraftEmissionRequestFormData;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    lockedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    lockedByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    organisationId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProduct
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum EmissionRequestProductProductRequestStatusEnum {
    NOT_STARTED = 'NOT_STARTED',
    REJECTED = 'REJECTED',
    REQUESTED = 'REQUESTED',
    PENDING_REVIEW = 'PENDING_REVIEW',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED'
}

/**
 * 
 * @export
 * @interface EmissionRequestProductFormData
 */
export interface EmissionRequestProductFormData {
    /**
     * 
     * @type {EmissionValues}
     * @memberof EmissionRequestProductFormData
     */
    emissionValues: EmissionValues;
    /**
     * 
     * @type {DataSources}
     * @memberof EmissionRequestProductFormData
     */
    dataSources: DataSources;
    /**
     * 
     * @type {Methodologies}
     * @memberof EmissionRequestProductFormData
     */
    methodologies: Methodologies;
    /**
     * 
     * @type {VerificationData}
     * @memberof EmissionRequestProductFormData
     */
    verificationData?: VerificationData;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestProductFormData
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface EmissionRequestResponse
 */
export interface EmissionRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestResponse
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestResponse
     */
    supplierId: string;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof EmissionRequestResponse
     */
    productIds: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface EmissionRequestSummary
 */
export interface EmissionRequestSummary {
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestSummary
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestSummary
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestSummary
     */
    supplierName: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestSummary
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestSummary
     */
    customerName: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRequestSummary
     */
    productRequestsAggregatedStatus: EmissionRequestSummaryProductRequestsAggregatedStatusEnum;
    /**
     * 
     * @type {ReadonlyArray<ProductDataRequestResponse>}
     * @memberof EmissionRequestSummary
     */
    productRequestResponseList: ReadonlyArray<ProductDataRequestResponse>;
}

/**
    * @export
    * @enum {string}
    */
export enum EmissionRequestSummaryProductRequestsAggregatedStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'
}

/**
 * 
 * @export
 * @interface EmissionRequestSummaryMetadataResponse
 */
export interface EmissionRequestSummaryMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof EmissionRequestSummaryMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRequestSummaryMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRequestSummaryMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface EmissionRequestSummaryResponse
 */
export interface EmissionRequestSummaryResponse {
    /**
     * 
     * @type {ReadonlyArray<EmissionRequestSummary>}
     * @memberof EmissionRequestSummaryResponse
     */
    items: ReadonlyArray<EmissionRequestSummary>;
    /**
     * 
     * @type {EmissionRequestSummaryMetadataResponse}
     * @memberof EmissionRequestSummaryResponse
     */
    metadata: EmissionRequestSummaryMetadataResponse;
}
/**
 * 
 * @export
 * @interface EmissionRequestTransientData
 */
export interface EmissionRequestTransientData {
    /**
     * 
     * @type {ReadonlyArray<EmissionRequestAttachmentData>}
     * @memberof EmissionRequestTransientData
     */
    attachments: ReadonlyArray<EmissionRequestAttachmentData>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EmissionType {
    _1 = 'SCOPE_1',
    _2 = 'SCOPE_2',
    _3 = 'SCOPE_3',
    _1_2 = 'SCOPE_1_2',
    _1_2_3 = 'SCOPE_1_2_3'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EmissionValueDataUsed {
    PRODUCT = 'PRODUCT',
    COMPANY = 'COMPANY'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EmissionValueGranularityLevel {
    DETAILED_LIFECYCLE = 'DETAILED_LIFECYCLE',
    LIFECYCLE = 'LIFECYCLE',
    PRODUCT = 'PRODUCT',
    CALCULATOR = 'CALCULATOR',
    SHARE_COMPANY = 'SHARE_COMPANY',
    UNAVAILABLE = 'UNAVAILABLE'
}

/**
 * 
 * @export
 * @interface EmissionValueItem
 */
export interface EmissionValueItem {
    /**
     * 
     * @type {LifecycleStage}
     * @memberof EmissionValueItem
     */
    lifecycleStage?: LifecycleStage;
    /**
     * 
     * @type {string}
     * @memberof EmissionValueItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EmissionValueItem
     */
    value: number;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof EmissionValueItem
     */
    unit: EmissionValueUnit;
    /**
     * 
     * @type {EmissionType}
     * @memberof EmissionValueItem
     */
    emissionType?: EmissionType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EmissionValueUnit {
    KGCO2_EQ_KM = 'KGCO2EQ_KM',
    KGCO2_EQ_KG = 'KGCO2EQ_KG',
    KGCO2_EQ_M2 = 'KGCO2EQ_M2',
    KGCO2_EQ_M3 = 'KGCO2EQ_M3',
    KGCO2_EQ_KWH = 'KGCO2EQ_KWH',
    KGCO2_EQ_KG_KM = 'KGCO2EQ_KG_KM',
    KGCO2_EQ_DAY = 'KGCO2EQ_DAY',
    KGCO2_EQ_USD = 'KGCO2EQ_USD',
    KGCO2_EQ_EUR = 'KGCO2EQ_EUR',
    KGCO2_EQ_DIMENSIONLESS = 'KGCO2EQ_DIMENSIONLESS',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface EmissionValues
 */
export interface EmissionValues {
    /**
     * 
     * @type {boolean}
     * @memberof EmissionValues
     */
    hasEmissionAlreadyAvailable?: boolean;
    /**
     * 
     * @type {EmissionValueGranularityLevel}
     * @memberof EmissionValues
     */
    emissionValuesGranularity: EmissionValueGranularityLevel;
    /**
     * 
     * @type {EmissionValuesLocation}
     * @memberof EmissionValues
     */
    emissionValuesLocation?: EmissionValuesLocation;
    /**
     * 
     * @type {EmissionsValuesBreakdown}
     * @memberof EmissionValues
     */
    emissionsValuesBreakdown?: EmissionsValuesBreakdown;
    /**
     * 
     * @type {ConfidenceLevel}
     * @memberof EmissionValues
     */
    confidence: ConfidenceLevel;
    /**
     * 
     * @type {string}
     * @memberof EmissionValues
     */
    additionalInformation?: string;
}
/**
 * 
 * @export
 * @interface EmissionValuesLocation
 */
export interface EmissionValuesLocation {
    /**
     * 
     * @type {string}
     * @memberof EmissionValuesLocation
     */
    locationType: EmissionValuesLocationLocationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionValuesLocation
     */
    region?: EmissionValuesLocationRegionEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionValuesLocation
     */
    country?: EmissionValuesLocationCountryEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EmissionValuesLocationLocationTypeEnum {
    GLOBAL = 'GLOBAL',
    REGIONAL = 'REGIONAL',
    COUNTRY = 'COUNTRY'
}
/**
    * @export
    * @enum {string}
    */
export enum EmissionValuesLocationRegionEnum {
    AFRICA = 'AFRICA',
    ANTARCTICA = 'ANTARCTICA',
    ASIA = 'ASIA',
    EUROPE = 'EUROPE',
    NORTH_AMERICA = 'NORTH_AMERICA',
    OCEANIA = 'OCEANIA',
    SOUTH_AMERICA = 'SOUTH_AMERICA'
}
/**
    * @export
    * @enum {string}
    */
export enum EmissionValuesLocationCountryEnum {
    AFG = 'AFG',
    AGO = 'AGO',
    ALB = 'ALB',
    ARE = 'ARE',
    ARG = 'ARG',
    ARM = 'ARM',
    ATA = 'ATA',
    AUS = 'AUS',
    AUT = 'AUT',
    AZE = 'AZE',
    BDI = 'BDI',
    BEL = 'BEL',
    BEN = 'BEN',
    BFA = 'BFA',
    BGD = 'BGD',
    BGR = 'BGR',
    BHS = 'BHS',
    BIH = 'BIH',
    BLR = 'BLR',
    BLZ = 'BLZ',
    BOL = 'BOL',
    BRA = 'BRA',
    BRN = 'BRN',
    BTN = 'BTN',
    BWA = 'BWA',
    CAF = 'CAF',
    CAN = 'CAN',
    CHE = 'CHE',
    CHL = 'CHL',
    CHN = 'CHN',
    CIV = 'CIV',
    CMR = 'CMR',
    COD = 'COD',
    COG = 'COG',
    COL = 'COL',
    CRI = 'CRI',
    CUB = 'CUB',
    CYP = 'CYP',
    CZE = 'CZE',
    DEU = 'DEU',
    DJI = 'DJI',
    DNK = 'DNK',
    DOM = 'DOM',
    DZA = 'DZA',
    ECU = 'ECU',
    EGY = 'EGY',
    ERI = 'ERI',
    ESP = 'ESP',
    EST = 'EST',
    ETH = 'ETH',
    FIN = 'FIN',
    FJI = 'FJI',
    FLK = 'FLK',
    FRA = 'FRA',
    GAB = 'GAB',
    GBR = 'GBR',
    GEO = 'GEO',
    GHA = 'GHA',
    GIN = 'GIN',
    GMB = 'GMB',
    GNB = 'GNB',
    GNQ = 'GNQ',
    GRC = 'GRC',
    GRL = 'GRL',
    GTM = 'GTM',
    GUY = 'GUY',
    HND = 'HND',
    HRV = 'HRV',
    HTI = 'HTI',
    HUN = 'HUN',
    IDN = 'IDN',
    IND = 'IND',
    IRL = 'IRL',
    IRN = 'IRN',
    IRQ = 'IRQ',
    ISL = 'ISL',
    ISR = 'ISR',
    ITA = 'ITA',
    JAM = 'JAM',
    JOR = 'JOR',
    JPN = 'JPN',
    KAZ = 'KAZ',
    KEN = 'KEN',
    KGZ = 'KGZ',
    KHM = 'KHM',
    KOR = 'KOR',
    KWT = 'KWT',
    LAO = 'LAO',
    LBN = 'LBN',
    LBR = 'LBR',
    LBY = 'LBY',
    LKA = 'LKA',
    LSO = 'LSO',
    LTU = 'LTU',
    LUX = 'LUX',
    LVA = 'LVA',
    MAR = 'MAR',
    MDA = 'MDA',
    MDG = 'MDG',
    MEX = 'MEX',
    MKD = 'MKD',
    MLI = 'MLI',
    MMR = 'MMR',
    MNE = 'MNE',
    MNG = 'MNG',
    MOZ = 'MOZ',
    MRT = 'MRT',
    MWI = 'MWI',
    MYS = 'MYS',
    NAM = 'NAM',
    NCL = 'NCL',
    NER = 'NER',
    NGA = 'NGA',
    NIC = 'NIC',
    NLD = 'NLD',
    NOR = 'NOR',
    NPL = 'NPL',
    NZL = 'NZL',
    OMN = 'OMN',
    PAK = 'PAK',
    PAN = 'PAN',
    PER = 'PER',
    PHL = 'PHL',
    PNG = 'PNG',
    POL = 'POL',
    PRI = 'PRI',
    PRK = 'PRK',
    PRT = 'PRT',
    PRY = 'PRY',
    PSE = 'PSE',
    QAT = 'QAT',
    ROU = 'ROU',
    RUS = 'RUS',
    RWA = 'RWA',
    ESH = 'ESH',
    SAU = 'SAU',
    SDN = 'SDN',
    SSD = 'SSD',
    SEN = 'SEN',
    SLB = 'SLB',
    SLE = 'SLE',
    SLV = 'SLV',
    SOM = 'SOM',
    SRB = 'SRB',
    SUR = 'SUR',
    SVK = 'SVK',
    SVN = 'SVN',
    SWE = 'SWE',
    SWZ = 'SWZ',
    SYR = 'SYR',
    TCD = 'TCD',
    TGO = 'TGO',
    THA = 'THA',
    TJK = 'TJK',
    TKM = 'TKM',
    TLS = 'TLS',
    TTO = 'TTO',
    TUN = 'TUN',
    TUR = 'TUR',
    TWN = 'TWN',
    TZA = 'TZA',
    UGA = 'UGA',
    UKR = 'UKR',
    URY = 'URY',
    USA = 'USA',
    UZB = 'UZB',
    VEN = 'VEN',
    VNM = 'VNM',
    VUT = 'VUT',
    YEM = 'YEM',
    ZAF = 'ZAF',
    ZMB = 'ZMB',
    ZWE = 'ZWE'
}

/**
 * 
 * @export
 * @interface EmissionsDataRequestResponse
 */
export interface EmissionsDataRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof EmissionsDataRequestResponse
     */
    reference: string;
    /**
     * 
     * @type {OrganisationResponse}
     * @memberof EmissionsDataRequestResponse
     */
    supplier: OrganisationResponse;
    /**
     * 
     * @type {Customer}
     * @memberof EmissionsDataRequestResponse
     */
    customer: Customer;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof EmissionsDataRequestResponse
     */
    productIds: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface EmissionsValuesBreakdown
 */
export interface EmissionsValuesBreakdown {
    /**
     * 
     * @type {ReadonlyArray<EmissionValueItem>}
     * @memberof EmissionsValuesBreakdown
     */
    materialAcquisitionAndPreprocessing: ReadonlyArray<EmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<EmissionValueItem>}
     * @memberof EmissionsValuesBreakdown
     */
    production: ReadonlyArray<EmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<EmissionValueItem>}
     * @memberof EmissionsValuesBreakdown
     */
    distributionAndStorage: ReadonlyArray<EmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<EmissionValueItem>}
     * @memberof EmissionsValuesBreakdown
     */
    productUse: ReadonlyArray<EmissionValueItem>;
    /**
     * 
     * @type {ReadonlyArray<EmissionValueItem>}
     * @memberof EmissionsValuesBreakdown
     */
    endOfLife: ReadonlyArray<EmissionValueItem>;
    /**
     * 
     * @type {number}
     * @memberof EmissionsValuesBreakdown
     */
    value?: number;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof EmissionsValuesBreakdown
     */
    unit?: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof EmissionsValuesBreakdown
     */
    unitOther?: string;
    /**
     * 
     * @type {EmissionValueDataUsed}
     * @memberof EmissionsValuesBreakdown
     */
    dataUsed?: EmissionValueDataUsed;
    /**
     * 
     * @type {string}
     * @memberof EmissionsValuesBreakdown
     */
    additionalComment?: string;
}
/**
 * 
 * @export
 * @interface FederateEmissionDataRequest
 */
export interface FederateEmissionDataRequest {
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionDataRequest
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionDataRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionDataRequest
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionDataRequest
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionDataRequest
     */
    productId: string;
    /**
     * 
     * @type {EmissionRequestProductFormData}
     * @memberof FederateEmissionDataRequest
     */
    emissionData: EmissionRequestProductFormData;
    /**
     * 
     * @type {EmissionRequestTransientData}
     * @memberof FederateEmissionDataRequest
     */
    transientData?: EmissionRequestTransientData;
}
/**
 * 
 * @export
 * @interface FederateEmissionRequest
 */
export interface FederateEmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionRequest
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionRequest
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionRequest
     */
    supplierId: string;
    /**
     * 
     * @type {ReadonlyArray<FederationEmissionProduct>}
     * @memberof FederateEmissionRequest
     */
    products: ReadonlyArray<FederationEmissionProduct>;
}
/**
 * 
 * @export
 * @interface FederateEmissionStatusUpdateRequest
 */
export interface FederateEmissionStatusUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    productStatus: FederateEmissionStatusUpdateRequestProductStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FederateEmissionStatusUpdateRequest
     */
    reason: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FederateEmissionStatusUpdateRequestProductStatusEnum {
    NOT_STARTED = 'NOT_STARTED',
    REJECTED = 'REJECTED',
    REQUESTED = 'REQUESTED',
    PENDING_REVIEW = 'PENDING_REVIEW',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED'
}

/**
 * 
 * @export
 * @interface FederatedInvitationStatusUpdatedRequest
 */
export interface FederatedInvitationStatusUpdatedRequest {
    /**
     * 
     * @type {string}
     * @memberof FederatedInvitationStatusUpdatedRequest
     */
    accessManagementToken: string;
    /**
     * 
     * @type {string}
     * @memberof FederatedInvitationStatusUpdatedRequest
     */
    customerId: string;
}
/**
 * 
 * @export
 * @interface FederationEmissionProduct
 */
export interface FederationEmissionProduct {
    /**
     * 
     * @type {string}
     * @memberof FederationEmissionProduct
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof FederationEmissionProduct
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof FederationEmissionProduct
     */
    productDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof FederationEmissionProduct
     */
    productInternalReference?: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof FederationEmissionProduct
     */
    productUnit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof FederationEmissionProduct
     */
    productRequestComment?: string;
}
/**
 * 
 * @export
 * @interface FieldValidationError
 */
export interface FieldValidationError {
    /**
     * 
     * @type {string}
     * @memberof FieldValidationError
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationError
     */
    message: string;
}
/**
 * 
 * @export
 * @interface FlattenedEmissionRequestListMetadata
 */
export interface FlattenedEmissionRequestListMetadata {
    /**
     * 
     * @type {number}
     * @memberof FlattenedEmissionRequestListMetadata
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof FlattenedEmissionRequestListMetadata
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof FlattenedEmissionRequestListMetadata
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface FlattenedEmissionRequestListResponse
 */
export interface FlattenedEmissionRequestListResponse {
    /**
     * 
     * @type {ReadonlyArray<FlattenedEmissionRequestResponse>}
     * @memberof FlattenedEmissionRequestListResponse
     */
    data: ReadonlyArray<FlattenedEmissionRequestResponse>;
    /**
     * 
     * @type {FlattenedEmissionRequestListMetadata}
     * @memberof FlattenedEmissionRequestListResponse
     */
    metadata: FlattenedEmissionRequestListMetadata;
}
/**
 * 
 * @export
 * @interface FlattenedEmissionRequestResponse
 */
export interface FlattenedEmissionRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    emissionRequestId: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    requestReference: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    organisationId: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    productName: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof FlattenedEmissionRequestResponse
     */
    productUnit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    customerName: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    productRequestStatus?: FlattenedEmissionRequestResponseProductRequestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FlattenedEmissionRequestResponse
     */
    emissionValue?: number;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedEmissionRequestResponse
     */
    templateId?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FlattenedEmissionRequestResponseProductRequestStatusEnum {
    NOT_STARTED = 'NOT_STARTED',
    REJECTED = 'REJECTED',
    REQUESTED = 'REQUESTED',
    PENDING_REVIEW = 'PENDING_REVIEW',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED'
}

/**
 * 
 * @export
 * @interface FootprintListResponse
 */
export interface FootprintListResponse {
    /**
     * 
     * @type {ProductListMetadataResponse}
     * @memberof FootprintListResponse
     */
    metadata: ProductListMetadataResponse;
    /**
     * 
     * @type {ReadonlyArray<ProductFootprint>}
     * @memberof FootprintListResponse
     */
    data: ReadonlyArray<ProductFootprint>;
}
/**
 * 
 * @export
 * @interface InvitationInfoResponse
 */
export interface InvitationInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof InvitationInfoResponse
     */
    recipientEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvitationInfoResponse
     */
    alreadyRegistered: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LifecycleStage {
    MATERIAL_ACQUISITION = 'MATERIAL_ACQUISITION',
    PRE_PROCESSING_PROCESSING = 'PRE_PROCESSING_PROCESSING',
    MINING_AND_EXTRACTION = 'MINING_AND_EXTRACTION',
    PHOTO_SYNTHESIS = 'PHOTO_SYNTHESIS',
    FERTILIZER = 'FERTILIZER',
    ENERGY = 'ENERGY',
    FUEL = 'FUEL',
    OPERATION_OF_PREMISES = 'OPERATION_OF_PREMISES',
    WASTE = 'WASTE',
    TRANSPORTATION_TO_PRODUCTION = 'TRANSPORTATION_TO_PRODUCTION',
    PHYSICAL_OR_CHEMICAL_PROCESSING = 'PHYSICAL_OR_CHEMICAL_PROCESSING',
    MANUFACTURING = 'MANUFACTURING',
    TRANSPORTATION_OF_SEMI_FINISHED = 'TRANSPORTATION_OF_SEMI_FINISHED',
    ASSEMBLY = 'ASSEMBLY',
    RECEIPT = 'RECEIPT',
    PUT_AWAY = 'PUT_AWAY',
    HEATING = 'HEATING',
    REFRIGERATION = 'REFRIGERATION',
    DISTRIBUTION = 'DISTRIBUTION',
    PACKAGING = 'PACKAGING',
    STORAGE = 'STORAGE',
    SHIPPING_TRANSPORTATION = 'SHIPPING_TRANSPORTATION',
    TRANSPORTATION_BETWEEN_STORAGE = 'TRANSPORTATION_BETWEEN_STORAGE',
    CONSUMER_USE = 'CONSUMER_USE',
    TRANSPORTATION_TO_USE_LOCATION = 'TRANSPORTATION_TO_USE_LOCATION',
    REFRIGERATION_AT_USE_LOCATION = 'REFRIGERATION_AT_USE_LOCATION',
    PREPARATION_FOR_USE = 'PREPARATION_FOR_USE',
    REPAIR_AND_MAINTENANCE = 'REPAIR_AND_MAINTENANCE',
    END_OF_LIFE_FINAL_DISPOSAL = 'END_OF_LIFE_FINAL_DISPOSAL',
    END_OF_LIFE_COLLECTION_AND_TRANSPORT = 'END_OF_LIFE_COLLECTION_AND_TRANSPORT',
    RECYCLING = 'RECYCLING',
    DISMANTLING = 'DISMANTLING',
    SHREDDING_AND_SORTING = 'SHREDDING_AND_SORTING',
    INCINERATION_AND_SORTING = 'INCINERATION_AND_SORTING',
    LAND_FILLING = 'LAND_FILLING',
    PRODUCTION = 'PRODUCTION',
    TRANSPORTATION = 'TRANSPORTATION',
    ENERGY_FUEL = 'ENERGY_FUEL'
}

/**
 * 
 * @export
 * @interface LinkAccountResponse
 */
export interface LinkAccountResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LinkAccountResponse
     */
    linked: boolean;
}
/**
 * 
 * @export
 * @interface LockInfo
 */
export interface LockInfo {
    /**
     * 
     * @type {string}
     * @memberof LockInfo
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof LockInfo
     */
    userName: string;
}
/**
 * 
 * @export
 * @interface LoginErrorResponse
 */
export interface LoginErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginErrorResponse
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginErrorResponse
     */
    error_description?: string;
}
/**
 * 
 * @export
 * @interface LoginUserRequest
 */
export interface LoginUserRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserRequest
     */
    password: string;
}
/**
 * 
 * @export
 * @interface LoginUserResponse
 */
export interface LoginUserResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponse
     */
    access_token: string;
    /**
     * 
     * @type {number}
     * @memberof LoginUserResponse
     */
    expires_in: number;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponse
     */
    id_token: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponse
     */
    refresh_token: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponse
     */
    scope: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponse
     */
    token_type: string;
}
/**
 * 
 * @export
 * @interface Methodologies
 */
export interface Methodologies {
    /**
     * 
     * @type {MethodologyStandards}
     * @memberof Methodologies
     */
    methodologyStandards: MethodologyStandards;
    /**
     * 
     * @type {string}
     * @memberof Methodologies
     */
    collectionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Methodologies
     */
    collectionEndDate?: string;
}
/**
 * 
 * @export
 * @interface MethodologyStandards
 */
export interface MethodologyStandards {
    /**
     * 
     * @type {string}
     * @memberof MethodologyStandards
     */
    standardCompliant: MethodologyStandardsStandardCompliantEnum;
    /**
     * 
     * @type {string}
     * @memberof MethodologyStandards
     */
    standardUsed?: MethodologyStandardsStandardUsedEnum;
    /**
     * 
     * @type {string}
     * @memberof MethodologyStandards
     */
    additionalInformation?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MethodologyStandardsStandardCompliantEnum {
    YES = 'YES',
    NO = 'NO',
    UNKNOWN = 'UNKNOWN'
}
/**
    * @export
    * @enum {string}
    */
export enum MethodologyStandardsStandardUsedEnum {
    ISO_3459 = 'ISO_3459',
    ISO_14040 = 'ISO_14040',
    ISO_14044 = 'ISO_14044',
    ISO_14067 = 'ISO_14067',
    PAS_2050 = 'PAS_2050',
    PRODUCT_ENVIRONMENTAL_FOOTPRINT = 'PRODUCT_ENVIRONMENTAL_FOOTPRINT',
    BP_X30_323_0 = 'BP_X30_323_0',
    EN_15804 = 'EN_15804',
    EPD_PRODUCT_CATEGORY_RULES = 'EPD_PRODUCT_CATEGORY_RULES',
    CALCULATOR = 'CALCULATOR',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface Organisation
 */
export interface Organisation {
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    dataFederationUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    co2AiCorpoUrl: string;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof Organisation
     */
    suppliers: ReadonlyArray<string>;
    /**
     * 
     * @type {number}
     * @memberof Organisation
     */
    customerCount: number;
}
/**
 * 
 * @export
 * @interface OrganisationInvitationReceivedListMetadataResponse
 */
export interface OrganisationInvitationReceivedListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationReceivedListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationReceivedListMetadataResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationReceivedListMetadataResponse
     */
    pageNumber: number;
}
/**
 * 
 * @export
 * @interface OrganisationInvitationReceivedListResponse
 */
export interface OrganisationInvitationReceivedListResponse {
    /**
     * 
     * @type {ReadonlyArray<OrganisationInvitationReceivedResponse>}
     * @memberof OrganisationInvitationReceivedListResponse
     */
    data: ReadonlyArray<OrganisationInvitationReceivedResponse>;
    /**
     * 
     * @type {OrganisationInvitationReceivedListMetadataResponse}
     * @memberof OrganisationInvitationReceivedListResponse
     */
    metadata: OrganisationInvitationReceivedListMetadataResponse;
}
/**
 * 
 * @export
 * @interface OrganisationInvitationReceivedResponse
 */
export interface OrganisationInvitationReceivedResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationReceivedResponse
     */
    invitationId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationReceivedResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationReceivedResponse
     */
    senderOrganisationName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationReceivedResponse
     */
    senderEmail?: string;
}
/**
 * 
 * @export
 * @interface OrganisationInvitationSentListMetadataResponse
 */
export interface OrganisationInvitationSentListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationSentListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationSentListMetadataResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationSentListMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationSentListMetadataResponse
     */
    pendingCount: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationSentListMetadataResponse
     */
    declinedCount: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationInvitationSentListMetadataResponse
     */
    acceptedCount: number;
}
/**
 * 
 * @export
 * @interface OrganisationInvitationSentListResponse
 */
export interface OrganisationInvitationSentListResponse {
    /**
     * 
     * @type {ReadonlyArray<OrganisationInvitationSentResponse>}
     * @memberof OrganisationInvitationSentListResponse
     */
    data: ReadonlyArray<OrganisationInvitationSentResponse>;
    /**
     * 
     * @type {OrganisationInvitationSentListMetadataResponse}
     * @memberof OrganisationInvitationSentListResponse
     */
    metadata: OrganisationInvitationSentListMetadataResponse;
}
/**
 * 
 * @export
 * @interface OrganisationInvitationSentResponse
 */
export interface OrganisationInvitationSentResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationSentResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationSentResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationSentResponse
     */
    accessResponseStatus: OrganisationInvitationSentResponseAccessResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganisationInvitationSentResponse
     */
    recipientEmail: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganisationInvitationSentResponseAccessResponseStatusEnum {
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED',
    PENDING = 'PENDING'
}

/**
 * 
 * @export
 * @interface OrganisationResponse
 */
export interface OrganisationResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganisationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface OrganisationsMetadataResponse
 */
export interface OrganisationsMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof OrganisationsMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationsMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationsMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface OrganisationsResponse
 */
export interface OrganisationsResponse {
    /**
     * 
     * @type {OrganisationsMetadataResponse}
     * @memberof OrganisationsResponse
     */
    metadata: OrganisationsMetadataResponse;
    /**
     * 
     * @type {ReadonlyArray<OrganisationResponse>}
     * @memberof OrganisationsResponse
     */
    data: ReadonlyArray<OrganisationResponse>;
}
/**
 * 
 * @export
 * @interface ProductCreateRequest
 */
export interface ProductCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductCreateRequest
     */
    name: string;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof ProductCreateRequest
     */
    supplierLinks: ReadonlyArray<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof ProductCreateRequest
     */
    unit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateRequest
     */
    internalReference: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateRequest
     */
    requestComment?: string;
}
/**
 * 
 * @export
 * @interface ProductDataRequestResponse
 */
export interface ProductDataRequestResponse {
    /**
     * 
     * @type {ProductResponse}
     * @memberof ProductDataRequestResponse
     */
    product: ProductResponse;
    /**
     * 
     * @type {EmissionDataRequest}
     * @memberof ProductDataRequestResponse
     */
    emissionDataRequest?: EmissionDataRequest;
    /**
     * 
     * @type {SupplierInformation}
     * @memberof ProductDataRequestResponse
     */
    supplierInformation?: SupplierInformation;
}
/**
 * 
 * @export
 * @interface ProductEmissionDataRequestDetailsResponse
 */
export interface ProductEmissionDataRequestDetailsResponse {
    /**
     * 
     * @type {ProductResponse}
     * @memberof ProductEmissionDataRequestDetailsResponse
     */
    productInformation: ProductResponse;
    /**
     * 
     * @type {OrganisationResponse}
     * @memberof ProductEmissionDataRequestDetailsResponse
     */
    supplierInformation: OrganisationResponse;
    /**
     * 
     * @type {EmissionRequestProductFormData}
     * @memberof ProductEmissionDataRequestDetailsResponse
     */
    emissionData?: EmissionRequestProductFormData;
    /**
     * 
     * @type {DraftEmissionRequestFormData}
     * @memberof ProductEmissionDataRequestDetailsResponse
     */
    emissionDraftData?: DraftEmissionRequestFormData;
    /**
     * 
     * @type {LockInfo}
     * @memberof ProductEmissionDataRequestDetailsResponse
     */
    editLock?: LockInfo;
}
/**
 * 
 * @export
 * @interface ProductEmissionDataRequestListResponse
 */
export interface ProductEmissionDataRequestListResponse {
    /**
     * 
     * @type {ProductListMetadataResponse}
     * @memberof ProductEmissionDataRequestListResponse
     */
    metadata: ProductListMetadataResponse;
    /**
     * 
     * @type {ReadonlyArray<ProductDataRequestResponse>}
     * @memberof ProductEmissionDataRequestListResponse
     */
    data: ReadonlyArray<ProductDataRequestResponse>;
}
/**
 * 
 * @export
 * @interface ProductFootprint
 */
export interface ProductFootprint {
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    specVersion: string;
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof ProductFootprint
     */
    precedingPfIds?: ReadonlyArray<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductFootprint
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    updated: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    statusComment?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    status: ProductFootprintStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    validityPeriodStart?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    validityPeriodEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    companyName: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof ProductFootprint
     */
    companyIds: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    productDescription: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof ProductFootprint
     */
    productIds: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    productCategoryCpc: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    productNameCompany: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFootprint
     */
    comment: string;
    /**
     * 
     * @type {CarbonFootprint}
     * @memberof ProductFootprint
     */
    pcf: CarbonFootprint;
    /**
     * 
     * @type {object}
     * @memberof ProductFootprint
     */
    extensions?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductFootprintStatusEnum {
    ACTIVE = 'Active',
    DEPRECATED = 'Deprecated'
}

/**
 * 
 * @export
 * @interface ProductImportResponse
 */
export interface ProductImportResponse {
    /**
     * 
     * @type {ReadonlyArray<ProductImportViolation>}
     * @memberof ProductImportResponse
     */
    violations: ReadonlyArray<ProductImportViolation>;
    /**
     * 
     * @type {ReadonlyArray<SupplierProductIdPair>}
     * @memberof ProductImportResponse
     */
    addedProducts: ReadonlyArray<SupplierProductIdPair>;
}
/**
 * 
 * @export
 * @interface ProductImportViolation
 */
export interface ProductImportViolation {
    /**
     * 
     * @type {boolean}
     * @memberof ProductImportViolation
     */
    isError: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductImportViolation
     */
    lineNumber: number;
    /**
     * 
     * @type {string}
     * @memberof ProductImportViolation
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof ProductImportViolation
     */
    violationType: ProductImportViolationViolationTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductImportViolationViolationTypeEnum {
    DUPLICATED_REFERENCE_IN_FILE = 'DUPLICATED_REFERENCE_IN_FILE',
    DUPLICATED_REFERENCE_IN_SYSTEM = 'DUPLICATED_REFERENCE_IN_SYSTEM',
    INVALID_FILE_FORMAT = 'INVALID_FILE_FORMAT',
    INVALID_HEADER = 'INVALID_HEADER',
    INVALID_NUMBER_OF_CELLS = 'INVALID_NUMBER_OF_CELLS',
    MISSING_PRODUCT_NAME = 'MISSING_PRODUCT_NAME',
    MISSING_PRODUCT_REFERENCE_NUMBER = 'MISSING_PRODUCT_REFERENCE_NUMBER'
}

/**
 * 
 * @export
 * @interface ProductListMetadataResponse
 */
export interface ProductListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface ProductRequestOverview
 */
export interface ProductRequestOverview {
    /**
     * 
     * @type {number}
     * @memberof ProductRequestOverview
     */
    notStarted: number;
    /**
     * 
     * @type {number}
     * @memberof ProductRequestOverview
     */
    requested: number;
    /**
     * 
     * @type {number}
     * @memberof ProductRequestOverview
     */
    declined: number;
    /**
     * 
     * @type {number}
     * @memberof ProductRequestOverview
     */
    rejected: number;
    /**
     * 
     * @type {number}
     * @memberof ProductRequestOverview
     */
    pendingReview: number;
    /**
     * 
     * @type {number}
     * @memberof ProductRequestOverview
     */
    completed: number;
}
/**
 * 
 * @export
 * @interface ProductResponse
 */
export interface ProductResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    requestComment?: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof ProductResponse
     */
    unit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    internalReference?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    productRequestStatus: ProductResponseProductRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductResponse
     */
    reason: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductResponseProductRequestStatusEnum {
    NOT_STARTED = 'NOT_STARTED',
    REJECTED = 'REJECTED',
    REQUESTED = 'REQUESTED',
    PENDING_REVIEW = 'PENDING_REVIEW',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED'
}

/**
 * 
 * @export
 * @interface ProductSupplierId
 */
export interface ProductSupplierId {
    /**
     * 
     * @type {string}
     * @memberof ProductSupplierId
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSupplierId
     */
    supplierId: string;
}
/**
 * 
 * @export
 * @interface ProductsDeleteRequest
 */
export interface ProductsDeleteRequest {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof ProductsDeleteRequest
     */
    productIds: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    refreshToken: string;
}
/**
 * 
 * @export
 * @interface RejectionReason
 */
export interface RejectionReason {
    /**
     * 
     * @type {string}
     * @memberof RejectionReason
     */
    reason: RejectionReasonReasonEnum;
    /**
     * 
     * @type {number}
     * @memberof RejectionReason
     */
    supplierCount: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RejectionReasonReasonEnum {
    PLANNING_TO_INTRODUCE_TARGET_IN_NEXT_TWO_YEARS = 'PLANNING_TO_INTRODUCE_TARGET_IN_NEXT_TWO_YEARS',
    IMPORTANT_BUT_NOT_IMMEDIATE_BUSINESS_PRIORITY = 'IMPORTANT_BUT_NOT_IMMEDIATE_BUSINESS_PRIORITY',
    JUDGED_TO_BE_UNIMPORTANT = 'JUDGED_TO_BE_UNIMPORTANT',
    LACK_OF_INTERNAL_RESOURCES = 'LACK_OF_INTERNAL_RESOURCES',
    INSUFFICIENT_DATA_ON_OPERATIONS = 'INSUFFICIENT_DATA_ON_OPERATIONS',
    NO_INSTRUCTION_FROM_MANAGEMENT = 'NO_INSTRUCTION_FROM_MANAGEMENT',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface RejectionReasons
 */
export interface RejectionReasons {
    /**
     * 
     * @type {RejectionReason}
     * @memberof RejectionReasons
     */
    first: RejectionReason;
    /**
     * 
     * @type {RejectionReason}
     * @memberof RejectionReasons
     */
    second?: RejectionReason;
    /**
     * 
     * @type {RejectionReason}
     * @memberof RejectionReasons
     */
    third?: RejectionReason;
}
/**
 * 
 * @export
 * @interface SbtiSupplierStatisticsResponse
 */
export interface SbtiSupplierStatisticsResponse {
    /**
     * 
     * @type {number}
     * @memberof SbtiSupplierStatisticsResponse
     */
    supplierCount: number;
    /**
     * 
     * @type {number}
     * @memberof SbtiSupplierStatisticsResponse
     */
    supplierWithSbtCount: number;
    /**
     * 
     * @type {number}
     * @memberof SbtiSupplierStatisticsResponse
     */
    validatedTargetCount: number;
    /**
     * 
     * @type {number}
     * @memberof SbtiSupplierStatisticsResponse
     */
    longTermTargetCount: number;
    /**
     * 
     * @type {number}
     * @memberof SbtiSupplierStatisticsResponse
     */
    declinedToSetTargetCount: number;
    /**
     * 
     * @type {RejectionReasons}
     * @memberof SbtiSupplierStatisticsResponse
     */
    mostFrequentRejectionReasons?: RejectionReasons;
}
/**
 * 
 * @export
 * @interface SbtiTargetRequest
 */
export interface SbtiTargetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SbtiTargetRequest
     */
    hasPlannedToCommit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetRequest
     */
    committedToSetYear?: number;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetRequest
     */
    nearTermTargetYear?: number;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetRequest
     */
    nearTermTargetClassification?: SbtiTargetRequestNearTermTargetClassificationEnum;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetRequest
     */
    longTermTargetYear?: number;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetRequest
     */
    longTermTargetClassification?: SbtiTargetRequestLongTermTargetClassificationEnum;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetRequest
     */
    netZeroTargetYear?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SbtiTargetRequest
     */
    isValidated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetRequest
     */
    rejectReason?: SbtiTargetRequestRejectReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetRequest
     */
    rejectComment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SbtiTargetRequestNearTermTargetClassificationEnum {
    WELL_BELOW_TWO_DEGREES = 'WELL_BELOW_TWO_DEGREES',
    ONE_POINT_FIVE_DEGREES = 'ONE_POINT_FIVE_DEGREES'
}
/**
    * @export
    * @enum {string}
    */
export enum SbtiTargetRequestLongTermTargetClassificationEnum {
    WELL_BELOW_TWO_DEGREES = 'WELL_BELOW_TWO_DEGREES',
    ONE_POINT_FIVE_DEGREES = 'ONE_POINT_FIVE_DEGREES'
}
/**
    * @export
    * @enum {string}
    */
export enum SbtiTargetRequestRejectReasonEnum {
    PLANNING_TO_INTRODUCE_TARGET_IN_NEXT_TWO_YEARS = 'PLANNING_TO_INTRODUCE_TARGET_IN_NEXT_TWO_YEARS',
    IMPORTANT_BUT_NOT_IMMEDIATE_BUSINESS_PRIORITY = 'IMPORTANT_BUT_NOT_IMMEDIATE_BUSINESS_PRIORITY',
    JUDGED_TO_BE_UNIMPORTANT = 'JUDGED_TO_BE_UNIMPORTANT',
    LACK_OF_INTERNAL_RESOURCES = 'LACK_OF_INTERNAL_RESOURCES',
    INSUFFICIENT_DATA_ON_OPERATIONS = 'INSUFFICIENT_DATA_ON_OPERATIONS',
    NO_INSTRUCTION_FROM_MANAGEMENT = 'NO_INSTRUCTION_FROM_MANAGEMENT',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface SbtiTargetResponse
 */
export interface SbtiTargetResponse {
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof SbtiTargetResponse
     */
    hasPlannedToCommit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetResponse
     */
    committedToSetYear?: number;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetResponse
     */
    nearTermTargetYear?: number;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetResponse
     */
    nearTermTargetClassification?: SbtiTargetResponseNearTermTargetClassificationEnum;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetResponse
     */
    longTermTargetYear?: number;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetResponse
     */
    longTermTargetClassification?: SbtiTargetResponseLongTermTargetClassificationEnum;
    /**
     * 
     * @type {number}
     * @memberof SbtiTargetResponse
     */
    netZeroTargetYear?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SbtiTargetResponse
     */
    isValidated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetResponse
     */
    rejectReason?: SbtiTargetResponseRejectReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof SbtiTargetResponse
     */
    rejectComment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SbtiTargetResponseNearTermTargetClassificationEnum {
    WELL_BELOW_TWO_DEGREES = 'WELL_BELOW_TWO_DEGREES',
    ONE_POINT_FIVE_DEGREES = 'ONE_POINT_FIVE_DEGREES'
}
/**
    * @export
    * @enum {string}
    */
export enum SbtiTargetResponseLongTermTargetClassificationEnum {
    WELL_BELOW_TWO_DEGREES = 'WELL_BELOW_TWO_DEGREES',
    ONE_POINT_FIVE_DEGREES = 'ONE_POINT_FIVE_DEGREES'
}
/**
    * @export
    * @enum {string}
    */
export enum SbtiTargetResponseRejectReasonEnum {
    PLANNING_TO_INTRODUCE_TARGET_IN_NEXT_TWO_YEARS = 'PLANNING_TO_INTRODUCE_TARGET_IN_NEXT_TWO_YEARS',
    IMPORTANT_BUT_NOT_IMMEDIATE_BUSINESS_PRIORITY = 'IMPORTANT_BUT_NOT_IMMEDIATE_BUSINESS_PRIORITY',
    JUDGED_TO_BE_UNIMPORTANT = 'JUDGED_TO_BE_UNIMPORTANT',
    LACK_OF_INTERNAL_RESOURCES = 'LACK_OF_INTERNAL_RESOURCES',
    INSUFFICIENT_DATA_ON_OPERATIONS = 'INSUFFICIENT_DATA_ON_OPERATIONS',
    NO_INSTRUCTION_FROM_MANAGEMENT = 'NO_INSTRUCTION_FROM_MANAGEMENT',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface SendInvitationsAgainRequest
 */
export interface SendInvitationsAgainRequest {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof SendInvitationsAgainRequest
     */
    invitedSupplierIds: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface SupplierEmissionRequestProductResponse
 */
export interface SupplierEmissionRequestProductResponse {
    /**
     * 
     * @type {ReadonlyArray<SupplierProductResponse>}
     * @memberof SupplierEmissionRequestProductResponse
     */
    data: ReadonlyArray<SupplierProductResponse>;
}
/**
 * 
 * @export
 * @interface SupplierInformation
 */
export interface SupplierInformation {
    /**
     * 
     * @type {string}
     * @memberof SupplierInformation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierInformation
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SupplierProductIdPair
 */
export interface SupplierProductIdPair {
    /**
     * 
     * @type {string}
     * @memberof SupplierProductIdPair
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductIdPair
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductIdPair
     */
    productName: string;
}
/**
 * 
 * @export
 * @interface SupplierProductResponse
 */
export interface SupplierProductResponse {
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    internalReference?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    lastUpdated: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierProductResponse
     */
    emissionFactor?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    emissionRequestReference: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierProductResponse
     */
    productId: string;
    /**
     * 
     * @type {EmissionValuesLocation}
     * @memberof SupplierProductResponse
     */
    emissionValuesLocation?: EmissionValuesLocation;
}
/**
 * 
 * @export
 * @interface SupplierResponse
 */
export interface SupplierResponse {
    /**
     * 
     * @type {string}
     * @memberof SupplierResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierResponse
     */
    name: string;
    /**
     * 
     * @type {SupplierResponseMetadata}
     * @memberof SupplierResponse
     */
    metadata: SupplierResponseMetadata;
}
/**
 * 
 * @export
 * @interface SupplierResponseMetadata
 */
export interface SupplierResponseMetadata {
    /**
     * 
     * @type {number}
     * @memberof SupplierResponseMetadata
     */
    totalNumberOfProducts: number;
}
/**
 * 
 * @export
 * @interface SuppliersMetadataResponse
 */
export interface SuppliersMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof SuppliersMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof SuppliersMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof SuppliersMetadataResponse
     */
    pageSize: number;
}
/**
 * 
 * @export
 * @interface SuppliersResponse
 */
export interface SuppliersResponse {
    /**
     * 
     * @type {SuppliersMetadataResponse}
     * @memberof SuppliersResponse
     */
    metadata: SuppliersMetadataResponse;
    /**
     * 
     * @type {ReadonlyArray<SupplierResponse>}
     * @memberof SuppliersResponse
     */
    data: ReadonlyArray<SupplierResponse>;
}
/**
 * 
 * @export
 * @interface TemplateCreateRequest
 */
export interface TemplateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    name: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof TemplateCreateRequest
     */
    unit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateRequest
     */
    internalReference?: string;
    /**
     * 
     * @type {DraftEmissionRequestFormData}
     * @memberof TemplateCreateRequest
     */
    emissionData?: DraftEmissionRequestFormData;
}
/**
 * 
 * @export
 * @interface TemplateDetailsResponse
 */
export interface TemplateDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof TemplateDetailsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateDetailsResponse
     */
    lastUpdated?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateDetailsResponse
     */
    name: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof TemplateDetailsResponse
     */
    unit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof TemplateDetailsResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateDetailsResponse
     */
    internalReference?: string;
    /**
     * 
     * @type {DraftEmissionRequestFormData}
     * @memberof TemplateDetailsResponse
     */
    emissionData?: DraftEmissionRequestFormData;
    /**
     * 
     * @type {number}
     * @memberof TemplateDetailsResponse
     */
    totalEmissionsValue?: number;
}
/**
 * 
 * @export
 * @interface TemplateImportResponse
 */
export interface TemplateImportResponse {
    /**
     * 
     * @type {ReadonlyArray<TemplateImportViolation>}
     * @memberof TemplateImportResponse
     */
    violations: ReadonlyArray<TemplateImportViolation>;
    /**
     * 
     * @type {ReadonlyArray<TemplateDetailsResponse>}
     * @memberof TemplateImportResponse
     */
    addedTemplates: ReadonlyArray<TemplateDetailsResponse>;
}
/**
 * 
 * @export
 * @interface TemplateImportViolation
 */
export interface TemplateImportViolation {
    /**
     * 
     * @type {boolean}
     * @memberof TemplateImportViolation
     */
    isError: boolean;
    /**
     * 
     * @type {number}
     * @memberof TemplateImportViolation
     */
    lineNumber: number;
    /**
     * 
     * @type {string}
     * @memberof TemplateImportViolation
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateImportViolation
     */
    violationType: TemplateImportViolationViolationTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TemplateImportViolationViolationTypeEnum {
    INVALID_FILE_FORMAT = 'INVALID_FILE_FORMAT',
    INVALID_HEADER = 'INVALID_HEADER',
    INVALID_NUMBER_OF_CELLS = 'INVALID_NUMBER_OF_CELLS',
    MISSING_PRODUCT_NAME = 'MISSING_PRODUCT_NAME',
    MISSING_PRODUCT_REFERENCE_NUMBER = 'MISSING_PRODUCT_REFERENCE_NUMBER'
}

/**
 * 
 * @export
 * @interface TemplateListMetadataResponse
 */
export interface TemplateListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof TemplateListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof TemplateListMetadataResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof TemplateListMetadataResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof TemplateListMetadataResponse
     */
    totalEmissionsValueOfAllTemplates: number;
}
/**
 * 
 * @export
 * @interface TemplateListResponse
 */
export interface TemplateListResponse {
    /**
     * 
     * @type {ReadonlyArray<TemplateResponse>}
     * @memberof TemplateListResponse
     */
    data: ReadonlyArray<TemplateResponse>;
    /**
     * 
     * @type {TemplateListMetadataResponse}
     * @memberof TemplateListResponse
     */
    metadata: TemplateListMetadataResponse;
}
/**
 * 
 * @export
 * @interface TemplateResponse
 */
export interface TemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof TemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateResponse
     */
    name: string;
    /**
     * 
     * @type {EmissionValueUnit}
     * @memberof TemplateResponse
     */
    unit: EmissionValueUnit;
    /**
     * 
     * @type {string}
     * @memberof TemplateResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateResponse
     */
    internalReference?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateResponse
     */
    lastUpdated?: string;
    /**
     * 
     * @type {number}
     * @memberof TemplateResponse
     */
    totalEmissionsValue?: number;
    /**
     * 
     * @type {DraftEmissionValuesLocation}
     * @memberof TemplateResponse
     */
    emissionValuesLocation?: DraftEmissionValuesLocation;
}
/**
 * 
 * @export
 * @interface UUIDListRequest
 */
export interface UUIDListRequest {
    /**
     * 
     * @type {ReadonlyArray<string>}
     * @memberof UUIDListRequest
     */
    ids: ReadonlyArray<string>;
}
/**
 * 
 * @export
 * @interface UpdateEmissionDraftDataRequest
 */
export interface UpdateEmissionDraftDataRequest {
    /**
     * 
     * @type {DraftEmissionRequestFormData}
     * @memberof UpdateEmissionDraftDataRequest
     */
    emissionDraftData?: DraftEmissionRequestFormData;
}
/**
 * 
 * @export
 * @interface UpdateOrganisationNameRequest
 */
export interface UpdateOrganisationNameRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationNameRequest
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface UpdateUserAccessLevelRequest
 */
export interface UpdateUserAccessLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccessLevelRequest
     */
    email: string;
    /**
     * 
     * @type {UserAccessLevel}
     * @memberof UpdateUserAccessLevelRequest
     */
    accessLevel: UserAccessLevel;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum UserAccessLevel {
    ADMIN = 'ADMIN',
    EDITOR = 'EDITOR'
}

/**
 * 
 * @export
 * @interface UserCreateRequest
 */
export interface UserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    accessManagementToken: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    userFullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    userJobTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    userPassword: string;
}
/**
 * 
 * @export
 * @interface UserInvitationListMetadataResponse
 */
export interface UserInvitationListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof UserInvitationListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UserInvitationListMetadataResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof UserInvitationListMetadataResponse
     */
    pageNumber: number;
}
/**
 * 
 * @export
 * @interface UserInvitationListResponse
 */
export interface UserInvitationListResponse {
    /**
     * 
     * @type {ReadonlyArray<UserInvitationResponse>}
     * @memberof UserInvitationListResponse
     */
    data: ReadonlyArray<UserInvitationResponse>;
    /**
     * 
     * @type {UserInvitationListMetadataResponse}
     * @memberof UserInvitationListResponse
     */
    metadata: UserInvitationListMetadataResponse;
}
/**
 * 
 * @export
 * @interface UserInvitationResponse
 */
export interface UserInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponse
     */
    recipientEmail: string;
}
/**
 * 
 * @export
 * @interface UserListMetadataResponse
 */
export interface UserListMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof UserListMetadataResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UserListMetadataResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof UserListMetadataResponse
     */
    pageNumber: number;
}
/**
 * 
 * @export
 * @interface UserListResponse
 */
export interface UserListResponse {
    /**
     * 
     * @type {ReadonlyArray<UserResponse>}
     * @memberof UserListResponse
     */
    data: ReadonlyArray<UserResponse>;
    /**
     * 
     * @type {UserListMetadataResponse}
     * @memberof UserListResponse
     */
    metadata: UserListMetadataResponse;
}
/**
 * 
 * @export
 * @interface UserResetPasswordRequest
 */
export interface UserResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UserResetPasswordRequest
     */
    userEmail: string;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    emissionRequestReceived: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    emissionRequestDeclined: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    emissionRequestReviewReady: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    emissionDataRejected: boolean;
    /**
     * 
     * @type {UserAccessLevel}
     * @memberof UserResponse
     */
    accessLevel: UserAccessLevel;
}
/**
 * 
 * @export
 * @interface UserUpdatePasswordRequest
 */
export interface UserUpdatePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UserUpdatePasswordRequest
     */
    accessManagementToken: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdatePasswordRequest
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdatePasswordRequest
     */
    userPassword: string;
}
/**
 * 
 * @export
 * @interface UserUpdateRequest
 */
export interface UserUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    emissionRequestReceived: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    emissionRequestDeclined: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    emissionRequestReviewReady: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    emissionDataRejected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    connectionRequestReceived: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    connectionRequestAccepted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateRequest
     */
    connectionRequestDeclined: boolean;
}
/**
 * 
 * @export
 * @interface VerificationAttachment
 */
export interface VerificationAttachment {
    /**
     * 
     * @type {string}
     * @memberof VerificationAttachment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationAttachment
     */
    name: string;
}
/**
 * 
 * @export
 * @interface VerificationData
 */
export interface VerificationData {
    /**
     * 
     * @type {boolean}
     * @memberof VerificationData
     */
    isDataVerified: boolean;
    /**
     * 
     * @type {VerificationProvider}
     * @memberof VerificationData
     */
    verificationProvider?: VerificationProvider;
    /**
     * 
     * @type {VerificationStandard}
     * @memberof VerificationData
     */
    verificationStandard?: VerificationStandard;
    /**
     * 
     * @type {string}
     * @memberof VerificationData
     */
    additionalVerificationProviderDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationData
     */
    additionalVerificationStandardDetails?: string;
    /**
     * 
     * @type {ReadonlyArray<VerificationAttachment>}
     * @memberof VerificationData
     */
    verificationAttachments?: ReadonlyArray<VerificationAttachment>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VerificationProvider {
    LRQA = 'LRQA',
    TOITU_ENVIROCARE = 'TOITU_ENVIROCARE',
    JMA = 'JMA',
    APEX = 'APEX',
    PROVIDER_3_R = 'PROVIDER_3R',
    AEC = 'AEC',
    CARBON_INTELLIGENCE = 'CARBON_INTELLIGENCE',
    CONSULTORA_AMBIENTAL_E3 = 'CONSULTORA_AMBIENTAL_E3',
    ENKING_INTERNATIONAL = 'ENKING_INTERNATIONAL',
    ENLIGHTEN = 'ENLIGHTEN',
    ISOS_GROUP = 'ISOS_GROUP',
    KERAMIDA = 'KERAMIDA',
    KPMG = 'KPMG',
    LUCIDEON = 'LUCIDEON',
    OPTERA = 'OPTERA',
    PETERSON_CONTROL_UNION = 'PETERSON_CONTROL_UNION',
    POSITION_GREEN = 'POSITION_GREEN',
    RIO = 'RIO',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum VerificationStandard {
    AA1000_AS = 'AA1000AS',
    ABNT_NBR_ISO_14064_3 = 'ABNT_NBR_ISO_14064_3',
    ACA = 'ACA',
    AICPA_AT_C_205 = 'AICPA_AT_C_205',
    AICPA_AT_C_210 = 'AICPA_AT_C_210',
    ASAE3000 = 'ASAE3000',
    ASGER = 'ASGER',
    ASSET = 'ASSET',
    CARBR = 'CARBR',
    CCAR = 'CCAR',
    CCEVS = 'CCEVS',
    CH_CO2 = 'CH_CO2',
    CICA_5025 = 'CICA_5025',
    CNCC = 'CNCC',
    CTS = 'CTS',
    DNV = 'DNV',
    DS_3000_A = 'DS_3000A',
    ECC = 'ECC',
    ERM_GHG = 'ERM_GHG',
    ERT_GHG = 'ERT_GHG',
    EU_ETS_V = 'EU_ETS_V',
    ICJCE = 'ICJCE',
    IDW_ASS_821 = 'IDW_ASS_821',
    IMEP_PROC_A = 'IMEP_PROC_A',
    ISAE_3000 = 'ISAE_3000',
    ISAE_3410 = 'ISAE_3410',
    ISO_14040 = 'ISO_14040',
    ISO_14044 = 'ISO_14044',
    ISO_14064_1 = 'ISO_14064_1',
    ISO_14064_3 = 'ISO_14064_3',
    JVETS = 'JVETS',
    KGHG_ETMS = 'KGHG_ETMS',
    NGER_ACT = 'NGER_ACT',
    NMX_SAA_14064_3_IMNC = 'NMX_SAA_14064_3_IMNC',
    REV_R_6_EN = 'REV_R_6_EN',
    S3810_N = 'S3810N',
    SGS_SRA = 'SGS_SRA',
    SPTSETP = 'SPTSETP',
    SSAE_3000 = 'SSAE_3000',
    TETS = 'TETS',
    TGO_GHG_VP = 'TGO_GHG_VP',
    TOITO_CRCS = 'TOITO_CRCS',
    OTHER = 'OTHER'
}


/**
 * CorpoControllerApi - axios parameter creator
 * @export
 */
export const CorpoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  List of products associated with a supplier 
         * @summary List of supplier products
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierProducts: async (supplierId: string, pageNumber?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listSupplierProducts', 'supplierId', supplierId)
            const localVarPath = `/api/corpo/suppliers/{supplierId}/products`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of suppliers for a specific organisation
         * @summary List of suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers1: async (pageNumber?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpo/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorpoControllerApi - functional programming interface
 * @export
 */
export const CorpoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CorpoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         *  List of products associated with a supplier 
         * @summary List of supplier products
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupplierProducts(supplierId: string, pageNumber?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorpoEmissionProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupplierProducts(supplierId, pageNumber, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of suppliers for a specific organisation
         * @summary List of suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSuppliers1(pageNumber?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorpoSuppliersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSuppliers1(pageNumber, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CorpoControllerApi - factory interface
 * @export
 */
export const CorpoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CorpoControllerApiFp(configuration)
    return {
        /**
         *  List of products associated with a supplier 
         * @summary List of supplier products
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierProducts(supplierId: string, pageNumber?: number, limit?: number, options?: any): AxiosPromise<CorpoEmissionProductListResponse> {
            return localVarFp.listSupplierProducts(supplierId, pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List of suppliers for a specific organisation
         * @summary List of suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers1(pageNumber?: number, limit?: number, options?: any): AxiosPromise<CorpoSuppliersResponse> {
            return localVarFp.listSuppliers1(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorpoControllerApi - object-oriented interface
 * @export
 * @class CorpoControllerApi
 * @extends {BaseAPI}
 */
export class CorpoControllerApi extends BaseAPI {
    /**
     *  List of products associated with a supplier 
     * @summary List of supplier products
     * @param {string} supplierId 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorpoControllerApi
     */
    public listSupplierProducts(supplierId: string, pageNumber?: number, limit?: number, options?: any) {
        return CorpoControllerApiFp(this.configuration).listSupplierProducts(supplierId, pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of suppliers for a specific organisation
     * @summary List of suppliers
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorpoControllerApi
     */
    public listSuppliers1(pageNumber?: number, limit?: number, options?: any) {
        return CorpoControllerApiFp(this.configuration).listSuppliers1(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerControllerApi - axios parameter creator
 * @export
 */
export const CustomerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List customers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers: async (pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerControllerApi - functional programming interface
 * @export
 */
export const CustomerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List customers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomers(pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomers(pageNumber, limit, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerControllerApi - factory interface
 * @export
 */
export const CustomerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary List customers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers(pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<OrganisationsResponse> {
            return localVarFp.listCustomers(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerControllerApi - object-oriented interface
 * @export
 * @class CustomerControllerApi
 * @extends {BaseAPI}
 */
export class CustomerControllerApi extends BaseAPI {
    /**
     * 
     * @summary List customers
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerControllerApi
     */
    public listCustomers(pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CustomerControllerApiFp(this.configuration).listCustomers(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerEmissionControllerApi - axios parameter creator
 * @export
 */
export const CustomerEmissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEmissionProductData: async (requestReference: string, productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('acceptEmissionProductData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('acceptEmissionProductData', 'productId', productId)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/accept`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Data Emission request
         * @param {CreateEmissionRequest} createEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmissionRequest: async (createEmissionRequest: CreateEmissionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmissionRequest' is not null or undefined
            assertParamExists('createEmissionRequest', 'createEmissionRequest', createEmissionRequest)
            const localVarPath = `/api/customer/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Details of Product Emissions Data Request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsOfDataEmissionRequest: async (requestReference: string, productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('detailsOfDataEmissionRequest', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('detailsOfDataEmissionRequest', 'productId', productId)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/details`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllEmissionRequests: async (fileName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/emission-requests/download/purchased`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment1: async (requestReference: string, productId: string, attachmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('downloadAttachment1', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('downloadAttachment1', 'productId', productId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment1', 'attachmentId', attachmentId)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/attachments/{attachmentId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {ReadonlyArray<string>} supplierIds 
         * @param {string} [fileName] 
         * @param {'CSV' | 'EXCEL' | 'PATHFINDER'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEmissionRequestsForSuppliers: async (supplierIds: ReadonlyArray<string>, fileName?: string, format?: 'CSV' | 'EXCEL' | 'PATHFINDER', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierIds' is not null or undefined
            assertParamExists('downloadEmissionRequestsForSuppliers', 'supplierIds', supplierIds)
            const localVarPath = `/api/customer/emission-requests/download/purchased/{supplierIds}`
                .replace(`{${"supplierIds"}}`, encodeURIComponent(String(supplierIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReceivedEmissionRequests: async (fileName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/emission-requests/download/received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Summary of Emission Requests sent
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'OPEN' | 'CLOSED'} [productRequestAggregatedStatus] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSentEmissionRequests: async (pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, productRequestAggregatedStatus?: 'OPEN' | 'CLOSED', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (productRequestAggregatedStatus !== undefined) {
                localVarQueryParameter['productRequestAggregatedStatus'] = productRequestAggregatedStatus;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmissionProductData: async (requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('rejectEmissionProductData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('rejectEmissionProductData', 'productId', productId)
            // verify required parameter 'emissionDataRejectionRequest' is not null or undefined
            assertParamExists('rejectEmissionProductData', 'emissionDataRejectionRequest', emissionDataRejectionRequest)
            const localVarPath = `/api/customer/emission-requests/{requestReference}/products/{productId}/reject`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerEmissionControllerApi - functional programming interface
 * @export
 */
export const CustomerEmissionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerEmissionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptEmissionProductData(requestReference: string, productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptEmissionProductData(requestReference, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Data Emission request
         * @param {CreateEmissionRequest} createEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmissionRequest(createEmissionRequest: CreateEmissionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmissionRequest(createEmissionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Details of Product Emissions Data Request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailsOfDataEmissionRequest(requestReference: string, productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailsOfDataEmissionRequest(requestReference, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllEmissionRequests(fileName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllEmissionRequests(fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment1(requestReference: string, productId: string, attachmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment1(requestReference, productId, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {ReadonlyArray<string>} supplierIds 
         * @param {string} [fileName] 
         * @param {'CSV' | 'EXCEL' | 'PATHFINDER'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEmissionRequestsForSuppliers(supplierIds: ReadonlyArray<string>, fileName?: string, format?: 'CSV' | 'EXCEL' | 'PATHFINDER', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEmissionRequestsForSuppliers(supplierIds, fileName, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadReceivedEmissionRequests(fileName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReceivedEmissionRequests(fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Summary of Emission Requests sent
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'OPEN' | 'CLOSED'} [productRequestAggregatedStatus] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSentEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, productRequestAggregatedStatus?: 'OPEN' | 'CLOSED', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSentEmissionRequests(pageNumber, limit, productRequestStatus, productRequestAggregatedStatus, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectEmissionProductData(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectEmissionProductData(requestReference, productId, emissionDataRejectionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerEmissionControllerApi - factory interface
 * @export
 */
export const CustomerEmissionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerEmissionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEmissionProductData(requestReference: string, productId: string, options?: any): AxiosPromise<void> {
            return localVarFp.acceptEmissionProductData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Data Emission request
         * @param {CreateEmissionRequest} createEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmissionRequest(createEmissionRequest: CreateEmissionRequest, options?: any): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.createEmissionRequest(createEmissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Details of Product Emissions Data Request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsOfDataEmissionRequest(requestReference: string, productId: string, options?: any): AxiosPromise<ProductEmissionDataRequestDetailsResponse> {
            return localVarFp.detailsOfDataEmissionRequest(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllEmissionRequests(fileName?: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadAllEmissionRequests(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment1(requestReference: string, productId: string, attachmentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadAttachment1(requestReference, productId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {ReadonlyArray<string>} supplierIds 
         * @param {string} [fileName] 
         * @param {'CSV' | 'EXCEL' | 'PATHFINDER'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEmissionRequestsForSuppliers(supplierIds: ReadonlyArray<string>, fileName?: string, format?: 'CSV' | 'EXCEL' | 'PATHFINDER', options?: any): AxiosPromise<any> {
            return localVarFp.downloadEmissionRequestsForSuppliers(supplierIds, fileName, format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads emission data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReceivedEmissionRequests(fileName?: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadReceivedEmissionRequests(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Summary of Emission Requests sent
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'OPEN' | 'CLOSED'} [productRequestAggregatedStatus] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSentEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, productRequestAggregatedStatus?: 'OPEN' | 'CLOSED', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<EmissionRequestSummaryResponse> {
            return localVarFp.getSentEmissionRequests(pageNumber, limit, productRequestStatus, productRequestAggregatedStatus, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject the Emission Data for a Product
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmissionProductData(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.rejectEmissionProductData(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerEmissionControllerApi - object-oriented interface
 * @export
 * @class CustomerEmissionControllerApi
 * @extends {BaseAPI}
 */
export class CustomerEmissionControllerApi extends BaseAPI {
    /**
     * 
     * @summary Accept the Emission Data for a Product
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public acceptEmissionProductData(requestReference: string, productId: string, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).acceptEmissionProductData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Data Emission request
     * @param {CreateEmissionRequest} createEmissionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public createEmissionRequest(createEmissionRequest: CreateEmissionRequest, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).createEmissionRequest(createEmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Details of Product Emissions Data Request
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public detailsOfDataEmissionRequest(requestReference: string, productId: string, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).detailsOfDataEmissionRequest(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads emission data
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public downloadAllEmissionRequests(fileName?: string, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadAllEmissionRequests(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download attachment
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public downloadAttachment1(requestReference: string, productId: string, attachmentId: string, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadAttachment1(requestReference, productId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads emission data
     * @param {ReadonlyArray<string>} supplierIds 
     * @param {string} [fileName] 
     * @param {'CSV' | 'EXCEL' | 'PATHFINDER'} [format] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public downloadEmissionRequestsForSuppliers(supplierIds: ReadonlyArray<string>, fileName?: string, format?: 'CSV' | 'EXCEL' | 'PATHFINDER', options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadEmissionRequestsForSuppliers(supplierIds, fileName, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads emission data
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public downloadReceivedEmissionRequests(fileName?: string, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).downloadReceivedEmissionRequests(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Summary of Emission Requests sent
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
     * @param {'OPEN' | 'CLOSED'} [productRequestAggregatedStatus] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public getSentEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, productRequestAggregatedStatus?: 'OPEN' | 'CLOSED', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).getSentEmissionRequests(pageNumber, limit, productRequestStatus, productRequestAggregatedStatus, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject the Emission Data for a Product
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerEmissionControllerApi
     */
    public rejectEmissionProductData(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: any) {
        return CustomerEmissionControllerApiFp(this.configuration).rejectEmissionProductData(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerProductControllerApi - axios parameter creator
 * @export
 */
export const CustomerProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create product
         * @param {ProductCreateRequest} productCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (productCreateRequest: ProductCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCreateRequest' is not null or undefined
            assertParamExists('createProduct', 'productCreateRequest', productCreateRequest)
            const localVarPath = `/api/customer/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import products from file
         * @param {string} supplierId 
         * @param {any} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProducts: async (supplierId: string, file: any, allowWarnings?: boolean, dryRun?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('importProducts', 'supplierId', supplierId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importProducts', 'file', file)
            const localVarPath = `/api/customer/products/import/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (allowWarnings !== undefined) {
                localVarQueryParameter['allowWarnings'] = allowWarnings;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerProductControllerApi - functional programming interface
 * @export
 */
export const CustomerProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create product
         * @param {ProductCreateRequest} productCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(productCreateRequest: ProductCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(productCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Import products from file
         * @param {string} supplierId 
         * @param {any} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProducts(supplierId: string, file: any, allowWarnings?: boolean, dryRun?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProducts(supplierId, file, allowWarnings, dryRun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerProductControllerApi - factory interface
 * @export
 */
export const CustomerProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create product
         * @param {ProductCreateRequest} productCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(productCreateRequest: ProductCreateRequest, options?: any): AxiosPromise<ProductResponse> {
            return localVarFp.createProduct(productCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import products from file
         * @param {string} supplierId 
         * @param {any} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProducts(supplierId: string, file: any, allowWarnings?: boolean, dryRun?: boolean, options?: any): AxiosPromise<ProductImportResponse> {
            return localVarFp.importProducts(supplierId, file, allowWarnings, dryRun, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerProductControllerApi - object-oriented interface
 * @export
 * @class CustomerProductControllerApi
 * @extends {BaseAPI}
 */
export class CustomerProductControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create product
     * @param {ProductCreateRequest} productCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerProductControllerApi
     */
    public createProduct(productCreateRequest: ProductCreateRequest, options?: any) {
        return CustomerProductControllerApiFp(this.configuration).createProduct(productCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import products from file
     * @param {string} supplierId 
     * @param {any} file 
     * @param {boolean} [allowWarnings] 
     * @param {boolean} [dryRun] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerProductControllerApi
     */
    public importProducts(supplierId: string, file: any, allowWarnings?: boolean, dryRun?: boolean, options?: any) {
        return CustomerProductControllerApiFp(this.configuration).importProducts(supplierId, file, allowWarnings, dryRun, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerSupplierControllerApi - axios parameter creator
 * @export
 */
export const CustomerSupplierControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel pending emission requests and delete link between customer and supplier
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuppliers: async (uUIDListRequest: UUIDListRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uUIDListRequest' is not null or undefined
            assertParamExists('deleteSuppliers', 'uUIDListRequest', uUIDListRequest)
            const localVarPath = `/api/customer/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uUIDListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Supplier by Id
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: async (supplierId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplier', 'supplierId', supplierId)
            const localVarPath = `/api/customer/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List products with emissions request information
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductEmissionRequests: async (supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listProductEmissionRequests', 'supplierId', supplierId)
            const localVarPath = `/api/customer/suppliers/{supplierId}/linked-products-with-emission-requests`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (productInternalReference !== undefined) {
                localVarQueryParameter['productInternalReference'] = productInternalReference;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (emissionDataVerified) {
                localVarQueryParameter['emissionDataVerified'] = emissionDataVerified;
            }

            if (emissionValueFrom !== undefined) {
                localVarQueryParameter['emissionValueFrom'] = emissionValueFrom;
            }

            if (emissionValueTo !== undefined) {
                localVarQueryParameter['emissionValueTo'] = emissionValueTo;
            }

            if (emissionValueConfidence) {
                localVarQueryParameter['emissionValueConfidence'] = emissionValueConfidence;
            }

            if (emissionValueGranularity) {
                localVarQueryParameter['emissionValueGranularity'] = emissionValueGranularity;
            }

            if (shareOfPrimaryDataInEmissionFactorFrom !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorFrom'] = shareOfPrimaryDataInEmissionFactorFrom;
            }

            if (shareOfPrimaryDataInEmissionFactorTo !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorTo'] = shareOfPrimaryDataInEmissionFactorTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers: async (pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerSupplierControllerApi - functional programming interface
 * @export
 */
export const CustomerSupplierControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerSupplierControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel pending emission requests and delete link between customer and supplier
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSuppliers(uUIDListRequest: UUIDListRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSuppliers(uUIDListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Supplier by Id
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplier(supplierId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplier(supplierId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List products with emissions request information
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProductEmissionRequests(supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProductEmissionRequests(supplierId, pageNumber, limit, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSuppliers(pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuppliersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSuppliers(pageNumber, limit, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerSupplierControllerApi - factory interface
 * @export
 */
export const CustomerSupplierControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerSupplierControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel pending emission requests and delete link between customer and supplier
         * @param {UUIDListRequest} uUIDListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuppliers(uUIDListRequest: UUIDListRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSuppliers(uUIDListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Supplier by Id
         * @param {string} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier(supplierId: string, options?: any): AxiosPromise<SupplierResponse> {
            return localVarFp.getSupplier(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List products with emissions request information
         * @param {string} supplierId 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductEmissionRequests(supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<ProductEmissionDataRequestListResponse> {
            return localVarFp.listProductEmissionRequests(supplierId, pageNumber, limit, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List suppliers
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers(pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<SuppliersResponse> {
            return localVarFp.listSuppliers(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerSupplierControllerApi - object-oriented interface
 * @export
 * @class CustomerSupplierControllerApi
 * @extends {BaseAPI}
 */
export class CustomerSupplierControllerApi extends BaseAPI {
    /**
     * 
     * @summary Cancel pending emission requests and delete link between customer and supplier
     * @param {UUIDListRequest} uUIDListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerSupplierControllerApi
     */
    public deleteSuppliers(uUIDListRequest: UUIDListRequest, options?: any) {
        return CustomerSupplierControllerApiFp(this.configuration).deleteSuppliers(uUIDListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Supplier by Id
     * @param {string} supplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerSupplierControllerApi
     */
    public getSupplier(supplierId: string, options?: any) {
        return CustomerSupplierControllerApiFp(this.configuration).getSupplier(supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List products with emissions request information
     * @param {string} supplierId 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {string} [productInternalReference] 
     * @param {string} [productName] 
     * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
     * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
     * @param {number} [emissionValueFrom] 
     * @param {number} [emissionValueTo] 
     * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
     * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
     * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerSupplierControllerApi
     */
    public listProductEmissionRequests(supplierId: string, pageNumber?: number, limit?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CustomerSupplierControllerApiFp(this.configuration).listProductEmissionRequests(supplierId, pageNumber, limit, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List suppliers
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {'DEFAULT' | 'PRODUCTS_CONNECTED'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerSupplierControllerApi
     */
    public listSuppliers(pageNumber?: number, limit?: number, sortBy?: 'DEFAULT' | 'PRODUCTS_CONNECTED', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CustomerSupplierControllerApiFp(this.configuration).listSuppliers(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataRequestFederationControllerApi - axios parameter creator
 * @export
 */
export const DataRequestFederationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Federate Emission Data
         * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionData: async (federateEmissionDataRequest: FederateEmissionDataRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateEmissionDataRequest' is not null or undefined
            assertParamExists('federateEmissionData', 'federateEmissionDataRequest', federateEmissionDataRequest)
            const localVarPath = `/api/federation/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateEmissionDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Federate Emission Data Product Status Update
         * @param {string} organisationId 
         * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionDataStatusUpdate: async (organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('federateEmissionDataStatusUpdate', 'organisationId', organisationId)
            // verify required parameter 'federateEmissionStatusUpdateRequest' is not null or undefined
            assertParamExists('federateEmissionDataStatusUpdate', 'federateEmissionStatusUpdateRequest', federateEmissionStatusUpdateRequest)
            const localVarPath = `/api/federation/emission-requests/organisation/{organisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateEmissionStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Federate Emission Request
         * @param {FederateEmissionRequest} federateEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionRequest: async (federateEmissionRequest: FederateEmissionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'federateEmissionRequest' is not null or undefined
            assertParamExists('federateEmissionRequest', 'federateEmissionRequest', federateEmissionRequest)
            const localVarPath = `/api/federation/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federateEmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataRequestFederationControllerApi - functional programming interface
 * @export
 */
export const DataRequestFederationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataRequestFederationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Federate Emission Data
         * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateEmissionData(federateEmissionDataRequest: FederateEmissionDataRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateEmissionData(federateEmissionDataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Federate Emission Data Product Status Update
         * @param {string} organisationId 
         * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateEmissionDataStatusUpdate(organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateEmissionDataStatusUpdate(organisationId, federateEmissionStatusUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Federate Emission Request
         * @param {FederateEmissionRequest} federateEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateEmissionRequest(federateEmissionRequest: FederateEmissionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateEmissionRequest(federateEmissionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataRequestFederationControllerApi - factory interface
 * @export
 */
export const DataRequestFederationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataRequestFederationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Federate Emission Data
         * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionData(federateEmissionDataRequest: FederateEmissionDataRequest, options?: any): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.federateEmissionData(federateEmissionDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Federate Emission Data Product Status Update
         * @param {string} organisationId 
         * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionDataStatusUpdate(organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options?: any): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.federateEmissionDataStatusUpdate(organisationId, federateEmissionStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Federate Emission Request
         * @param {FederateEmissionRequest} federateEmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateEmissionRequest(federateEmissionRequest: FederateEmissionRequest, options?: any): AxiosPromise<EmissionRequestResponse> {
            return localVarFp.federateEmissionRequest(federateEmissionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataRequestFederationControllerApi - object-oriented interface
 * @export
 * @class DataRequestFederationControllerApi
 * @extends {BaseAPI}
 */
export class DataRequestFederationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Federate Emission Data
     * @param {FederateEmissionDataRequest} federateEmissionDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataRequestFederationControllerApi
     */
    public federateEmissionData(federateEmissionDataRequest: FederateEmissionDataRequest, options?: any) {
        return DataRequestFederationControllerApiFp(this.configuration).federateEmissionData(federateEmissionDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Federate Emission Data Product Status Update
     * @param {string} organisationId 
     * @param {FederateEmissionStatusUpdateRequest} federateEmissionStatusUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataRequestFederationControllerApi
     */
    public federateEmissionDataStatusUpdate(organisationId: string, federateEmissionStatusUpdateRequest: FederateEmissionStatusUpdateRequest, options?: any) {
        return DataRequestFederationControllerApiFp(this.configuration).federateEmissionDataStatusUpdate(organisationId, federateEmissionStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Federate Emission Request
     * @param {FederateEmissionRequest} federateEmissionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataRequestFederationControllerApi
     */
    public federateEmissionRequest(federateEmissionRequest: FederateEmissionRequest, options?: any) {
        return DataRequestFederationControllerApiFp(this.configuration).federateEmissionRequest(federateEmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FootprintControllerApi - axios parameter creator
 * @export
 */
export const FootprintControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/2/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFootprint: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFootprint', 'id', id)
            const localVarPath = `/api/2/footprints/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFootprints: async (pageNumber?: number, limit?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/2/footprints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FootprintControllerApi - functional programming interface
 * @export
 */
export const FootprintControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FootprintControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFootprint(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductFootprint>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFootprint(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFootprints(pageNumber?: number, limit?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FootprintListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFootprints(pageNumber, limit, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FootprintControllerApi - factory interface
 * @export
 */
export const FootprintControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FootprintControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFootprint(id: string, options?: any): AxiosPromise<ProductFootprint> {
            return localVarFp.getFootprint(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFootprints(pageNumber?: number, limit?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<FootprintListResponse> {
            return localVarFp.listFootprints(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FootprintControllerApi - object-oriented interface
 * @export
 * @class FootprintControllerApi
 * @extends {BaseAPI}
 */
export class FootprintControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FootprintControllerApi
     */
    public getEvents(options?: any) {
        return FootprintControllerApiFp(this.configuration).getEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FootprintControllerApi
     */
    public getFootprint(id: string, options?: any) {
        return FootprintControllerApiFp(this.configuration).getFootprint(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FootprintControllerApi
     */
    public listFootprints(pageNumber?: number, limit?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return FootprintControllerApiFp(this.configuration).listFootprints(pageNumber, limit, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrgInvitationUpdateFederationControllerApi - axios parameter creator
 * @export
 */
export const OrgInvitationUpdateFederationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Federate Invitation Status Update
         * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateInvitationStatusUpdate: async (federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'federatedInvitationStatusUpdatedRequest' is not null or undefined
            assertParamExists('federateInvitationStatusUpdate', 'federatedInvitationStatusUpdatedRequest', federatedInvitationStatusUpdatedRequest)
            const localVarPath = `/api/federation/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(federatedInvitationStatusUpdatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrgInvitationUpdateFederationControllerApi - functional programming interface
 * @export
 */
export const OrgInvitationUpdateFederationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrgInvitationUpdateFederationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Federate Invitation Status Update
         * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrgInvitationUpdateFederationControllerApi - factory interface
 * @export
 */
export const OrgInvitationUpdateFederationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrgInvitationUpdateFederationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Federate Invitation Status Update
         * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options?: any): AxiosPromise<void> {
            return localVarFp.federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrgInvitationUpdateFederationControllerApi - object-oriented interface
 * @export
 * @class OrgInvitationUpdateFederationControllerApi
 * @extends {BaseAPI}
 */
export class OrgInvitationUpdateFederationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Federate Invitation Status Update
     * @param {FederatedInvitationStatusUpdatedRequest} federatedInvitationStatusUpdatedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgInvitationUpdateFederationControllerApi
     */
    public federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest: FederatedInvitationStatusUpdatedRequest, options?: any) {
        return OrgInvitationUpdateFederationControllerApiFp(this.configuration).federateInvitationStatusUpdate(federatedInvitationStatusUpdatedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationAttachmentControllerApi - axios parameter creator
 * @export
 */
export const OrganisationAttachmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Safe delete attachments
         * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachments: async (attachmentsDeleteRequest: AttachmentsDeleteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentsDeleteRequest' is not null or undefined
            assertParamExists('deleteAttachments', 'attachmentsDeleteRequest', attachmentsDeleteRequest)
            const localVarPath = `/api/organisation/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Attachments
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachments: async (pageNumber?: number, limit?: number, searchTerm?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads an attachment
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAttachment', 'file', file)
            const localVarPath = `/api/organisation/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationAttachmentControllerApi - functional programming interface
 * @export
 */
export const OrganisationAttachmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationAttachmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Safe delete attachments
         * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachments(attachmentsDeleteRequest: AttachmentsDeleteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentsDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachments(attachmentsDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List Attachments
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAttachments(pageNumber?: number, limit?: number, searchTerm?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAttachments(pageNumber, limit, searchTerm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uploads an attachment
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationAttachmentControllerApi - factory interface
 * @export
 */
export const OrganisationAttachmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationAttachmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Safe delete attachments
         * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachments(attachmentsDeleteRequest: AttachmentsDeleteRequest, options?: any): AxiosPromise<AttachmentsDeleteResponse> {
            return localVarFp.deleteAttachments(attachmentsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Attachments
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachments(pageNumber?: number, limit?: number, searchTerm?: string, options?: any): AxiosPromise<AttachmentListResponse> {
            return localVarFp.listAttachments(pageNumber, limit, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads an attachment
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(file: any, options?: any): AxiosPromise<AttachmentInfo> {
            return localVarFp.uploadAttachment(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationAttachmentControllerApi - object-oriented interface
 * @export
 * @class OrganisationAttachmentControllerApi
 * @extends {BaseAPI}
 */
export class OrganisationAttachmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary Safe delete attachments
     * @param {AttachmentsDeleteRequest} attachmentsDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAttachmentControllerApi
     */
    public deleteAttachments(attachmentsDeleteRequest: AttachmentsDeleteRequest, options?: any) {
        return OrganisationAttachmentControllerApiFp(this.configuration).deleteAttachments(attachmentsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Attachments
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAttachmentControllerApi
     */
    public listAttachments(pageNumber?: number, limit?: number, searchTerm?: string, options?: any) {
        return OrganisationAttachmentControllerApiFp(this.configuration).listAttachments(pageNumber, limit, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads an attachment
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationAttachmentControllerApi
     */
    public uploadAttachment(file: any, options?: any) {
        return OrganisationAttachmentControllerApiFp(this.configuration).uploadAttachment(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationControllerApi - axios parameter creator
 * @export
 */
export const OrganisationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve aggregated emission request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedRequestDataOverview: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/emission-request-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get own Organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrganisation: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SBTI Target statistics for suppliers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSbtiTargetStatistics: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/sbti-target/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get own SBTI targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSbtiTargets: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/sbti-target`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save SBTI Target
         * @param {SbtiTargetRequest} sbtiTargetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSbtiTarget: async (sbtiTargetRequest: SbtiTargetRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sbtiTargetRequest' is not null or undefined
            assertParamExists('saveSbtiTarget', 'sbtiTargetRequest', sbtiTargetRequest)
            const localVarPath = `/api/organisation/sbti-target`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sbtiTargetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organisation name
         * @param {UpdateOrganisationNameRequest} updateOrganisationNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisationName: async (updateOrganisationNameRequest: UpdateOrganisationNameRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOrganisationNameRequest' is not null or undefined
            assertParamExists('updateOrganisationName', 'updateOrganisationNameRequest', updateOrganisationNameRequest)
            const localVarPath = `/api/organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganisationNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationControllerApi - functional programming interface
 * @export
 */
export const OrganisationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve aggregated emission request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedRequestDataOverview(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedRequestDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedRequestDataOverview(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get own Organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnOrganisation(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organisation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnOrganisation(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get SBTI Target statistics for suppliers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSbtiTargetStatistics(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SbtiSupplierStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSbtiTargetStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get own SBTI targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSbtiTargets(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SbtiTargetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSbtiTargets(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save SBTI Target
         * @param {SbtiTargetRequest} sbtiTargetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSbtiTarget(sbtiTargetRequest: SbtiTargetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SbtiTargetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSbtiTarget(sbtiTargetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Organisation name
         * @param {UpdateOrganisationNameRequest} updateOrganisationNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganisationName(updateOrganisationNameRequest: UpdateOrganisationNameRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organisation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganisationName(updateOrganisationNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationControllerApi - factory interface
 * @export
 */
export const OrganisationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve aggregated emission request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedRequestDataOverview(options?: any): AxiosPromise<AggregatedRequestDataResponse> {
            return localVarFp.getAggregatedRequestDataOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get own Organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrganisation(options?: any): AxiosPromise<Organisation> {
            return localVarFp.getOwnOrganisation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get SBTI Target statistics for suppliers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSbtiTargetStatistics(options?: any): AxiosPromise<SbtiSupplierStatisticsResponse> {
            return localVarFp.getSbtiTargetStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get own SBTI targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSbtiTargets(options?: any): AxiosPromise<SbtiTargetResponse> {
            return localVarFp.getSbtiTargets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save SBTI Target
         * @param {SbtiTargetRequest} sbtiTargetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSbtiTarget(sbtiTargetRequest: SbtiTargetRequest, options?: any): AxiosPromise<SbtiTargetResponse> {
            return localVarFp.saveSbtiTarget(sbtiTargetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organisation name
         * @param {UpdateOrganisationNameRequest} updateOrganisationNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisationName(updateOrganisationNameRequest: UpdateOrganisationNameRequest, options?: any): AxiosPromise<Organisation> {
            return localVarFp.updateOrganisationName(updateOrganisationNameRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationControllerApi - object-oriented interface
 * @export
 * @class OrganisationControllerApi
 * @extends {BaseAPI}
 */
export class OrganisationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve aggregated emission request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationControllerApi
     */
    public getAggregatedRequestDataOverview(options?: any) {
        return OrganisationControllerApiFp(this.configuration).getAggregatedRequestDataOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get own Organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationControllerApi
     */
    public getOwnOrganisation(options?: any) {
        return OrganisationControllerApiFp(this.configuration).getOwnOrganisation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get SBTI Target statistics for suppliers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationControllerApi
     */
    public getSbtiTargetStatistics(options?: any) {
        return OrganisationControllerApiFp(this.configuration).getSbtiTargetStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get own SBTI targets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationControllerApi
     */
    public getSbtiTargets(options?: any) {
        return OrganisationControllerApiFp(this.configuration).getSbtiTargets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save SBTI Target
     * @param {SbtiTargetRequest} sbtiTargetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationControllerApi
     */
    public saveSbtiTarget(sbtiTargetRequest: SbtiTargetRequest, options?: any) {
        return OrganisationControllerApiFp(this.configuration).saveSbtiTarget(sbtiTargetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organisation name
     * @param {UpdateOrganisationNameRequest} updateOrganisationNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationControllerApi
     */
    public updateOrganisationName(updateOrganisationNameRequest: UpdateOrganisationNameRequest, options?: any) {
        return OrganisationControllerApiFp(this.configuration).updateOrganisationName(updateOrganisationNameRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationInvitationControllerApi - axios parameter creator
 * @export
 */
export const OrganisationInvitationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accepts an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (invitationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('acceptInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/organisation/access-management/{invitationId}/accept`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (createInvitationsRequest: CreateInvitationsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationsRequest' is not null or undefined
            assertParamExists('createInvitation', 'createInvitationsRequest', createInvitationsRequest)
            const localVarPath = `/api/organisation/access-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Declines an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvitation: async (invitationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('declineInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/organisation/access-management/{invitationId}/decline`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List received invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivedInvitations: async (pageNumber?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/access-management/received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List sent invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>} [accessResponseStatus] 
         * @param {'CREATED_AT'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSentInvitations: async (pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>, sortBy?: 'CREATED_AT', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/access-management/sent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (accessResponseStatus) {
                localVarQueryParameter['accessResponseStatus'] = accessResponseStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send organisation invitations again
         * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrgInvitationsAgain: async (sendInvitationsAgainRequest: SendInvitationsAgainRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendInvitationsAgainRequest' is not null or undefined
            assertParamExists('sendOrgInvitationsAgain', 'sendInvitationsAgainRequest', sendInvitationsAgainRequest)
            const localVarPath = `/api/organisation/access-management/send-again`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendInvitationsAgainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationInvitationControllerApi - functional programming interface
 * @export
 */
export const OrganisationInvitationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationInvitationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accepts an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(invitationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(createInvitationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Declines an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineInvitation(invitationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineInvitation(invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List received invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReceivedInvitations(pageNumber?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationInvitationReceivedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReceivedInvitations(pageNumber, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List sent invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>} [accessResponseStatus] 
         * @param {'CREATED_AT'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSentInvitations(pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>, sortBy?: 'CREATED_AT', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationInvitationSentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSentInvitations(pageNumber, limit, accessResponseStatus, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send organisation invitations again
         * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOrgInvitationsAgain(sendInvitationsAgainRequest: SendInvitationsAgainRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOrgInvitationsAgain(sendInvitationsAgainRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationInvitationControllerApi - factory interface
 * @export
 */
export const OrganisationInvitationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationInvitationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Accepts an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(invitationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.acceptInvitation(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: any): AxiosPromise<EmailTokensResponse> {
            return localVarFp.createInvitation(createInvitationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Declines an invitation
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvitation(invitationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.declineInvitation(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List received invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivedInvitations(pageNumber?: number, limit?: number, options?: any): AxiosPromise<OrganisationInvitationReceivedListResponse> {
            return localVarFp.listReceivedInvitations(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List sent invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>} [accessResponseStatus] 
         * @param {'CREATED_AT'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSentInvitations(pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>, sortBy?: 'CREATED_AT', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<OrganisationInvitationSentListResponse> {
            return localVarFp.listSentInvitations(pageNumber, limit, accessResponseStatus, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send organisation invitations again
         * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrgInvitationsAgain(sendInvitationsAgainRequest: SendInvitationsAgainRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendOrgInvitationsAgain(sendInvitationsAgainRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationInvitationControllerApi - object-oriented interface
 * @export
 * @class OrganisationInvitationControllerApi
 * @extends {BaseAPI}
 */
export class OrganisationInvitationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Accepts an invitation
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationInvitationControllerApi
     */
    public acceptInvitation(invitationId: string, options?: any) {
        return OrganisationInvitationControllerApiFp(this.configuration).acceptInvitation(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send invitations
     * @param {CreateInvitationsRequest} createInvitationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationInvitationControllerApi
     */
    public createInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: any) {
        return OrganisationInvitationControllerApiFp(this.configuration).createInvitation(createInvitationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Declines an invitation
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationInvitationControllerApi
     */
    public declineInvitation(invitationId: string, options?: any) {
        return OrganisationInvitationControllerApiFp(this.configuration).declineInvitation(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List received invitations
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationInvitationControllerApi
     */
    public listReceivedInvitations(pageNumber?: number, limit?: number, options?: any) {
        return OrganisationInvitationControllerApiFp(this.configuration).listReceivedInvitations(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List sent invitations
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>} [accessResponseStatus] 
     * @param {'CREATED_AT'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationInvitationControllerApi
     */
    public listSentInvitations(pageNumber?: number, limit?: number, accessResponseStatus?: ReadonlyArray<'ACCEPTED' | 'DECLINED' | 'PENDING'>, sortBy?: 'CREATED_AT', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return OrganisationInvitationControllerApiFp(this.configuration).listSentInvitations(pageNumber, limit, accessResponseStatus, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send organisation invitations again
     * @param {SendInvitationsAgainRequest} sendInvitationsAgainRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationInvitationControllerApi
     */
    public sendOrgInvitationsAgain(sendInvitationsAgainRequest: SendInvitationsAgainRequest, options?: any) {
        return OrganisationInvitationControllerApiFp(this.configuration).sendOrgInvitationsAgain(sendInvitationsAgainRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationUserAccessManagementControllerApi - axios parameter creator
 * @export
 */
export const OrganisationUserAccessManagementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create user access request
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccessRequest: async (emailListRequest: EmailListRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('createUserAccessRequest', 'emailListRequest', emailListRequest)
            const localVarPath = `/api/organisation/users/access-management/access-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send user invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserInvitation: async (createInvitationsRequest: CreateInvitationsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationsRequest' is not null or undefined
            assertParamExists('createUserInvitation', 'createInvitationsRequest', createInvitationsRequest)
            const localVarPath = `/api/organisation/users/access-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete user invitations
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserInvitation: async (emailListRequest: EmailListRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('deleteUserInvitation', 'emailListRequest', emailListRequest)
            const localVarPath = `/api/organisation/users/access-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List pending invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingUserInvitation: async (pageNumber?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users/access-management/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send user invitations again
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserInvitationsAgain: async (emailListRequest: EmailListRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('sendUserInvitationsAgain', 'emailListRequest', emailListRequest)
            const localVarPath = `/api/organisation/users/access-management/send-again`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationUserAccessManagementControllerApi - functional programming interface
 * @export
 */
export const OrganisationUserAccessManagementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationUserAccessManagementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create user access request
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserAccessRequest(emailListRequest: EmailListRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserAccessRequest(emailListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send user invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserInvitation(createInvitationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete user invitations
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserInvitation(emailListRequest: EmailListRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserInvitation(emailListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List pending invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPendingUserInvitation(pageNumber?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInvitationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPendingUserInvitation(pageNumber, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send user invitations again
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserInvitationsAgain(emailListRequest: EmailListRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserInvitationsAgain(emailListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationUserAccessManagementControllerApi - factory interface
 * @export
 */
export const OrganisationUserAccessManagementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationUserAccessManagementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create user access request
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccessRequest(emailListRequest: EmailListRequest, options?: any): AxiosPromise<EmailTokensResponse> {
            return localVarFp.createUserAccessRequest(emailListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send user invitations
         * @param {CreateInvitationsRequest} createInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createUserInvitation(createInvitationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete user invitations
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserInvitation(emailListRequest: EmailListRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserInvitation(emailListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List pending invitations
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingUserInvitation(pageNumber?: number, limit?: number, options?: any): AxiosPromise<UserInvitationListResponse> {
            return localVarFp.listPendingUserInvitation(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send user invitations again
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserInvitationsAgain(emailListRequest: EmailListRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendUserInvitationsAgain(emailListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationUserAccessManagementControllerApi - object-oriented interface
 * @export
 * @class OrganisationUserAccessManagementControllerApi
 * @extends {BaseAPI}
 */
export class OrganisationUserAccessManagementControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create user access request
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserAccessManagementControllerApi
     */
    public createUserAccessRequest(emailListRequest: EmailListRequest, options?: any) {
        return OrganisationUserAccessManagementControllerApiFp(this.configuration).createUserAccessRequest(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send user invitations
     * @param {CreateInvitationsRequest} createInvitationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserAccessManagementControllerApi
     */
    public createUserInvitation(createInvitationsRequest: CreateInvitationsRequest, options?: any) {
        return OrganisationUserAccessManagementControllerApiFp(this.configuration).createUserInvitation(createInvitationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete user invitations
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserAccessManagementControllerApi
     */
    public deleteUserInvitation(emailListRequest: EmailListRequest, options?: any) {
        return OrganisationUserAccessManagementControllerApiFp(this.configuration).deleteUserInvitation(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List pending invitations
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserAccessManagementControllerApi
     */
    public listPendingUserInvitation(pageNumber?: number, limit?: number, options?: any) {
        return OrganisationUserAccessManagementControllerApiFp(this.configuration).listPendingUserInvitation(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send user invitations again
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserAccessManagementControllerApi
     */
    public sendUserInvitationsAgain(emailListRequest: EmailListRequest, options?: any) {
        return OrganisationUserAccessManagementControllerApiFp(this.configuration).sendUserInvitationsAgain(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationUserControllerApi - axios parameter creator
 * @export
 */
export const OrganisationUserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current logged in user user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an organisation user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/api/organisation/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List organisation users
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (pageNumber?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organisation/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an organisation user
         * @param {UserUpdateRequest} userUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userUpdateRequest: UserUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdateRequest' is not null or undefined
            assertParamExists('updateUser', 'userUpdateRequest', userUpdateRequest)
            const localVarPath = `/api/organisation/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user access level
         * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccessLevel: async (updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserAccessLevelRequest' is not null or undefined
            assertParamExists('updateUserAccessLevel', 'updateUserAccessLevelRequest', updateUserAccessLevelRequest)
            const localVarPath = `/api/organisation/users/update-access-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccessLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationUserControllerApi - functional programming interface
 * @export
 */
export const OrganisationUserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationUserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current logged in user user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an organisation user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List organisation users
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(pageNumber?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(pageNumber, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an organisation user
         * @param {UserUpdateRequest} userUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userUpdateRequest: UserUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a user access level
         * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccessLevel(updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccessLevel(updateUserAccessLevelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationUserControllerApi - factory interface
 * @export
 */
export const OrganisationUserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationUserControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current logged in user user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): AxiosPromise<UserResponse> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an organisation user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, options?: any): AxiosPromise<UserResponse> {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List organisation users
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(pageNumber?: number, limit?: number, options?: any): AxiosPromise<UserListResponse> {
            return localVarFp.listUsers(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an organisation user
         * @param {UserUpdateRequest} userUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userUpdateRequest: UserUpdateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateUser(userUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user access level
         * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccessLevel(updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserAccessLevel(updateUserAccessLevelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationUserControllerApi - object-oriented interface
 * @export
 * @class OrganisationUserControllerApi
 * @extends {BaseAPI}
 */
export class OrganisationUserControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get current logged in user user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserControllerApi
     */
    public getCurrentUser(options?: any) {
        return OrganisationUserControllerApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an organisation user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserControllerApi
     */
    public getUser(userId: string, options?: any) {
        return OrganisationUserControllerApiFp(this.configuration).getUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List organisation users
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserControllerApi
     */
    public listUsers(pageNumber?: number, limit?: number, options?: any) {
        return OrganisationUserControllerApiFp(this.configuration).listUsers(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an organisation user
     * @param {UserUpdateRequest} userUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserControllerApi
     */
    public updateUser(userUpdateRequest: UserUpdateRequest, options?: any) {
        return OrganisationUserControllerApiFp(this.configuration).updateUser(userUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user access level
     * @param {UpdateUserAccessLevelRequest} updateUserAccessLevelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationUserControllerApi
     */
    public updateUserAccessLevel(updateUserAccessLevelRequest: UpdateUserAccessLevelRequest, options?: any) {
        return OrganisationUserControllerApiFp(this.configuration).updateUserAccessLevel(updateUserAccessLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductControllerApi - axios parameter creator
 * @export
 */
export const ProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete emission requests and associated products
         * @param {ProductsDeleteRequest} productsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEmissionRequests: async (productsDeleteRequest: ProductsDeleteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productsDeleteRequest' is not null or undefined
            assertParamExists('cancelEmissionRequests', 'productsDeleteRequest', productsDeleteRequest)
            const localVarPath = `/api/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Emission Requests for multiple products and suppliers
         * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmissionRequests: async (createEmissionRequestsRequest: CreateEmissionRequestsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmissionRequestsRequest' is not null or undefined
            assertParamExists('createEmissionRequests', 'createEmissionRequestsRequest', createEmissionRequestsRequest)
            const localVarPath = `/api/product/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmissionRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overview of aggregated product request age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestAgeOverview: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/request-age-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve aggregated product request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestDataOverview: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/request-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchased products
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedProducts: async (pageNumber?: number, limit?: number, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/purchased-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (supplierIds) {
                localVarQueryParameter['supplierIds'] = supplierIds;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (productInternalReference !== undefined) {
                localVarQueryParameter['productInternalReference'] = productInternalReference;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (emissionDataVerified) {
                localVarQueryParameter['emissionDataVerified'] = emissionDataVerified;
            }

            if (emissionValueFrom !== undefined) {
                localVarQueryParameter['emissionValueFrom'] = emissionValueFrom;
            }

            if (emissionValueTo !== undefined) {
                localVarQueryParameter['emissionValueTo'] = emissionValueTo;
            }

            if (emissionValueConfidence) {
                localVarQueryParameter['emissionValueConfidence'] = emissionValueConfidence;
            }

            if (emissionValueGranularity) {
                localVarQueryParameter['emissionValueGranularity'] = emissionValueGranularity;
            }

            if (shareOfPrimaryDataInEmissionFactorFrom !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorFrom'] = shareOfPrimaryDataInEmissionFactorFrom;
            }

            if (shareOfPrimaryDataInEmissionFactorTo !== undefined) {
                localVarQueryParameter['shareOfPrimaryDataInEmissionFactorTo'] = shareOfPrimaryDataInEmissionFactorTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get received products requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivedProductRequests: async (pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS', sortDirection?: 'ASC' | 'DESC', lastUpdatedFrom?: string, lastUpdatedTo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/received-product-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (customerIds) {
                localVarQueryParameter['customerIds'] = customerIds;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductControllerApi - functional programming interface
 * @export
 */
export const ProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete emission requests and associated products
         * @param {ProductsDeleteRequest} productsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelEmissionRequests(productsDeleteRequest: ProductsDeleteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelEmissionRequests(productsDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Emission Requests for multiple products and suppliers
         * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmissionRequests(createEmissionRequestsRequest: CreateEmissionRequestsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmissionRequests(createEmissionRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Overview of aggregated product request age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedProductRequestAgeOverview(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedProductRequestAgeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedProductRequestAgeOverview(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve aggregated product request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedProductRequestDataOverview(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedProductRequestDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedProductRequestDataOverview(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchased products
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchasedProducts(pageNumber?: number, limit?: number, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchasedProducts(pageNumber, limit, supplierIds, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get received products requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReceivedProductRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS', sortDirection?: 'ASC' | 'DESC', lastUpdatedFrom?: string, lastUpdatedTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlattenedEmissionRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceivedProductRequests(pageNumber, limit, customerIds, productRequestStatus, sortBy, sortDirection, lastUpdatedFrom, lastUpdatedTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductControllerApi - factory interface
 * @export
 */
export const ProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete emission requests and associated products
         * @param {ProductsDeleteRequest} productsDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEmissionRequests(productsDeleteRequest: ProductsDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.cancelEmissionRequests(productsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Emission Requests for multiple products and suppliers
         * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmissionRequests(createEmissionRequestsRequest: CreateEmissionRequestsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createEmissionRequests(createEmissionRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overview of aggregated product request age
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestAgeOverview(options?: any): AxiosPromise<AggregatedProductRequestAgeResponse> {
            return localVarFp.getAggregatedProductRequestAgeOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve aggregated product request data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedProductRequestDataOverview(options?: any): AxiosPromise<AggregatedProductRequestDataResponse> {
            return localVarFp.getAggregatedProductRequestDataOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchased products
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [supplierIds] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [productInternalReference] 
         * @param {string} [productName] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
         * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
         * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
         * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedProducts(pageNumber?: number, limit?: number, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<ProductEmissionDataRequestListResponse> {
            return localVarFp.getPurchasedProducts(pageNumber, limit, supplierIds, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get received products requests
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<string>} [customerIds] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivedProductRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS', sortDirection?: 'ASC' | 'DESC', lastUpdatedFrom?: string, lastUpdatedTo?: string, options?: any): AxiosPromise<FlattenedEmissionRequestListResponse> {
            return localVarFp.getReceivedProductRequests(pageNumber, limit, customerIds, productRequestStatus, sortBy, sortDirection, lastUpdatedFrom, lastUpdatedTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductControllerApi - object-oriented interface
 * @export
 * @class ProductControllerApi
 * @extends {BaseAPI}
 */
export class ProductControllerApi extends BaseAPI {
    /**
     * 
     * @summary Delete emission requests and associated products
     * @param {ProductsDeleteRequest} productsDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public cancelEmissionRequests(productsDeleteRequest: ProductsDeleteRequest, options?: any) {
        return ProductControllerApiFp(this.configuration).cancelEmissionRequests(productsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Emission Requests for multiple products and suppliers
     * @param {CreateEmissionRequestsRequest} createEmissionRequestsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public createEmissionRequests(createEmissionRequestsRequest: CreateEmissionRequestsRequest, options?: any) {
        return ProductControllerApiFp(this.configuration).createEmissionRequests(createEmissionRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overview of aggregated product request age
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getAggregatedProductRequestAgeOverview(options?: any) {
        return ProductControllerApiFp(this.configuration).getAggregatedProductRequestAgeOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve aggregated product request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getAggregatedProductRequestDataOverview(options?: any) {
        return ProductControllerApiFp(this.configuration).getAggregatedProductRequestDataOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchased products
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<string>} [supplierIds] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {string} [productInternalReference] 
     * @param {string} [productName] 
     * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
     * @param {ReadonlyArray<boolean>} [emissionDataVerified] 
     * @param {number} [emissionValueFrom] 
     * @param {number} [emissionValueTo] 
     * @param {ReadonlyArray<ConfidenceLevel>} [emissionValueConfidence] 
     * @param {ReadonlyArray<EmissionValueGranularityLevel>} [emissionValueGranularity] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorFrom] 
     * @param {number} [shareOfPrimaryDataInEmissionFactorTo] 
     * @param {'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getPurchasedProducts(pageNumber?: number, limit?: number, supplierIds?: ReadonlyArray<string>, lastUpdatedFrom?: string, lastUpdatedTo?: string, productInternalReference?: string, productName?: string, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, emissionDataVerified?: ReadonlyArray<boolean>, emissionValueFrom?: number, emissionValueTo?: number, emissionValueConfidence?: ReadonlyArray<ConfidenceLevel>, emissionValueGranularity?: ReadonlyArray<EmissionValueGranularityLevel>, shareOfPrimaryDataInEmissionFactorFrom?: number, shareOfPrimaryDataInEmissionFactorTo?: number, sortBy?: 'PRODUCT_REQUEST_STATUS' | 'INTERNAL_REFERENCE' | 'UPDATED_AT' | 'PRODUCT_UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return ProductControllerApiFp(this.configuration).getPurchasedProducts(pageNumber, limit, supplierIds, lastUpdatedFrom, lastUpdatedTo, productInternalReference, productName, productRequestStatus, emissionDataVerified, emissionValueFrom, emissionValueTo, emissionValueConfidence, emissionValueGranularity, shareOfPrimaryDataInEmissionFactorFrom, shareOfPrimaryDataInEmissionFactorTo, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get received products requests
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<string>} [customerIds] 
     * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
     * @param {'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getReceivedProductRequests(pageNumber?: number, limit?: number, customerIds?: ReadonlyArray<string>, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE' | 'PRODUCT_REQUEST_STATUS', sortDirection?: 'ASC' | 'DESC', lastUpdatedFrom?: string, lastUpdatedTo?: string, options?: any) {
        return ProductControllerApiFp(this.configuration).getReceivedProductRequests(pageNumber, limit, customerIds, productRequestStatus, sortBy, sortDirection, lastUpdatedFrom, lastUpdatedTo, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegistrationControllerApi - axios parameter creator
 * @export
 */
export const RegistrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUserAccessRequest: async (token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('approveUserAccessRequest', 'token', token)
            const localVarPath = `/auth/registration/users/approve-access-request/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a company is already registered
         * @param {CompanyExistsRequest} companyExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCompanyExists: async (companyExistsRequest: CompanyExistsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyExistsRequest' is not null or undefined
            assertParamExists('checkCompanyExists', 'companyExistsRequest', companyExistsRequest)
            const localVarPath = `/auth/registration/accounts/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyExistsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new account
         * @param {AccountCreateRequest} accountCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (accountCreateRequest: AccountCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountCreateRequest' is not null or undefined
            assertParamExists('createAccount', 'accountCreateRequest', accountCreateRequest)
            const localVarPath = `/auth/registration/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new user
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (userCreateRequest: UserCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateRequest' is not null or undefined
            assertParamExists('createUser', 'userCreateRequest', userCreateRequest)
            const localVarPath = `/auth/registration/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete accounts
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccounts: async (emailListRequest: EmailListRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailListRequest' is not null or undefined
            assertParamExists('deleteAccounts', 'emailListRequest', emailListRequest)
            const localVarPath = `/auth/registration/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deny user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyUserAccessRequest: async (token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('denyUserAccessRequest', 'token', token)
            const localVarPath = `/auth/registration/users/deny-access-request/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invite detail
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitation: async (token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getInvitation', 'token', token)
            const localVarPath = `/auth/registration/invitations/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link a connected SSO account to an existing account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/registration/accounts/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {LoginUserRequest} loginUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser: async (loginUserRequest: LoginUserRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginUserRequest' is not null or undefined
            assertParamExists('loginUser', 'loginUserRequest', loginUserRequest)
            const localVarPath = `/auth/registration/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUserPact: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('loginUserPact', 'authorization', authorization)
            const localVarPath = `/auth/registration/users/auth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate an access token / id token from a refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequest: RefreshTokenRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/auth/registration/users/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates user password reset request
         * @param {UserResetPasswordRequest} userResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (userResetPasswordRequest: UserResetPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userResetPasswordRequest' is not null or undefined
            assertParamExists('resetUserPassword', 'userResetPasswordRequest', userResetPasswordRequest)
            const localVarPath = `/auth/registration/users/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates user password
         * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (userUpdatePasswordRequest: UserUpdatePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdatePasswordRequest' is not null or undefined
            assertParamExists('updateUserPassword', 'userUpdatePasswordRequest', userUpdatePasswordRequest)
            const localVarPath = `/auth/registration/users/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationControllerApi - functional programming interface
 * @export
 */
export const RegistrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveUserAccessRequest(token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveUserAccessRequest(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if a company is already registered
         * @param {CompanyExistsRequest} companyExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCompanyExists(companyExistsRequest: CompanyExistsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyExistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCompanyExists(companyExistsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new account
         * @param {AccountCreateRequest} accountCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(accountCreateRequest: AccountCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(accountCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new user
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(userCreateRequest: UserCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(userCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete accounts
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccounts(emailListRequest: EmailListRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccounts(emailListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deny user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async denyUserAccessRequest(token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.denyUserAccessRequest(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get invite detail
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitation(token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitation(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Link a connected SSO account to an existing account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {LoginUserRequest} loginUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUser(loginUserRequest: LoginUserRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUser(loginUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUserPact(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUserPact(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate an access token / id token from a refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates user password reset request
         * @param {UserResetPasswordRequest} userResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(userResetPasswordRequest: UserResetPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(userResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates user password
         * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(userUpdatePasswordRequest: UserUpdatePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(userUpdatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationControllerApi - factory interface
 * @export
 */
export const RegistrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUserAccessRequest(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.approveUserAccessRequest(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a company is already registered
         * @param {CompanyExistsRequest} companyExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCompanyExists(companyExistsRequest: CompanyExistsRequest, options?: any): AxiosPromise<CompanyExistsResponse> {
            return localVarFp.checkCompanyExists(companyExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new account
         * @param {AccountCreateRequest} accountCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(accountCreateRequest: AccountCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createAccount(accountCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new user
         * @param {UserCreateRequest} userCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreateRequest: UserCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createUser(userCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete accounts
         * @param {EmailListRequest} emailListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccounts(emailListRequest: EmailListRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAccounts(emailListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deny user access request
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyUserAccessRequest(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.denyUserAccessRequest(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invite detail
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitation(token: string, options?: any): AxiosPromise<InvitationInfoResponse> {
            return localVarFp.getInvitation(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link a connected SSO account to an existing account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccount(options?: any): AxiosPromise<LinkAccountResponse> {
            return localVarFp.linkAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {LoginUserRequest} loginUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser(loginUserRequest: LoginUserRequest, options?: any): AxiosPromise<LoginUserResponse> {
            return localVarFp.loginUser(loginUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with an existing user
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUserPact(authorization: string, options?: any): AxiosPromise<LoginUserResponse> {
            return localVarFp.loginUserPact(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate an access token / id token from a refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: any): AxiosPromise<LoginUserResponse> {
            return localVarFp.refreshToken(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates user password reset request
         * @param {UserResetPasswordRequest} userResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(userResetPasswordRequest: UserResetPasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.resetUserPassword(userResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates user password
         * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(userUpdatePasswordRequest: UserUpdatePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserPassword(userUpdatePasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationControllerApi - object-oriented interface
 * @export
 * @class RegistrationControllerApi
 * @extends {BaseAPI}
 */
export class RegistrationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Approve user access request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public approveUserAccessRequest(token: string, options?: any) {
        return RegistrationControllerApiFp(this.configuration).approveUserAccessRequest(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a company is already registered
     * @param {CompanyExistsRequest} companyExistsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public checkCompanyExists(companyExistsRequest: CompanyExistsRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).checkCompanyExists(companyExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new account
     * @param {AccountCreateRequest} accountCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public createAccount(accountCreateRequest: AccountCreateRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).createAccount(accountCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new user
     * @param {UserCreateRequest} userCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public createUser(userCreateRequest: UserCreateRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).createUser(userCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete accounts
     * @param {EmailListRequest} emailListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public deleteAccounts(emailListRequest: EmailListRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).deleteAccounts(emailListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deny user access request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public denyUserAccessRequest(token: string, options?: any) {
        return RegistrationControllerApiFp(this.configuration).denyUserAccessRequest(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invite detail
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public getInvitation(token: string, options?: any) {
        return RegistrationControllerApiFp(this.configuration).getInvitation(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link a connected SSO account to an existing account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public linkAccount(options?: any) {
        return RegistrationControllerApiFp(this.configuration).linkAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with an existing user
     * @param {LoginUserRequest} loginUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public loginUser(loginUserRequest: LoginUserRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).loginUser(loginUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with an existing user
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public loginUserPact(authorization: string, options?: any) {
        return RegistrationControllerApiFp(this.configuration).loginUserPact(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate an access token / id token from a refresh token
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).refreshToken(refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates user password reset request
     * @param {UserResetPasswordRequest} userResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public resetUserPassword(userResetPasswordRequest: UserResetPasswordRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).resetUserPassword(userResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates user password
     * @param {UserUpdatePasswordRequest} userUpdatePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public updateUserPassword(userUpdatePasswordRequest: UserUpdatePasswordRequest, options?: any) {
        return RegistrationControllerApiFp(this.configuration).updateUserPassword(userUpdatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupplierEmissionControllerApi - axios parameter creator
 * @export
 */
export const SupplierEmissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Decline emission data request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineEmissionRequest: async (requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('declineEmissionRequest', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('declineEmissionRequest', 'productId', productId)
            // verify required parameter 'emissionDataRejectionRequest' is not null or undefined
            assertParamExists('declineEmissionRequest', 'emissionDataRejectionRequest', emissionDataRejectionRequest)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/decline`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionDataRejectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment: async (requestReference: string, productId: string, attachmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('downloadAttachment', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('downloadAttachment', 'productId', productId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/attachments/{attachmentId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get emissions data request product details
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProductDetails: async (requestReference: string, productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('getEmissionRequestProductDetails', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getEmissionRequestProductDetails', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get emission request products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProducts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/supplier/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Summary of Emission Requests received
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivedEmissionRequests: async (pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/supplier/emission-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (productRequestStatus) {
                localVarQueryParameter['productRequestStatus'] = productRequestStatus;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEmissionData: async (requestReference: string, productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('lockEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('lockEmissionData', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/lock`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auto-save interim emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistDraftEmissionData: async (requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('persistDraftEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('persistDraftEmissionData', 'productId', productId)
            // verify required parameter 'updateEmissionDraftDataRequest' is not null or undefined
            assertParamExists('persistDraftEmissionData', 'updateEmissionDraftDataRequest', updateEmissionDraftDataRequest)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/draft`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmissionDraftDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Emission Data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEmissionData: async (requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('submitEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('submitEmissionData', 'productId', productId)
            // verify required parameter 'emissionRequestProductFormData' is not null or undefined
            assertParamExists('submitEmissionData', 'emissionRequestProductFormData', emissionRequestProductFormData)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionRequestProductFormData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Un-locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unLockEmissionData: async (requestReference: string, productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('unLockEmissionData', 'requestReference', requestReference)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('unLockEmissionData', 'productId', productId)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}/products/{productId}/lock`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierEmissionControllerApi - functional programming interface
 * @export
 */
export const SupplierEmissionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierEmissionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Decline emission data request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineEmissionRequest(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineEmissionRequest(requestReference, productId, emissionDataRejectionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment(requestReference: string, productId: string, attachmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment(requestReference, productId, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get emissions data request product details
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissionRequestProductDetails(requestReference: string, productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissionRequestProductDetails(requestReference, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get emission request products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissionRequestProducts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierEmissionRequestProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissionRequestProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Summary of Emission Requests received
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReceivedEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReceivedEmissionRequests(pageNumber, limit, productRequestStatus, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockEmissionData(requestReference: string, productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockEmissionData(requestReference, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Auto-save interim emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistDraftEmissionData(requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEmissionDataRequestDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistDraftEmissionData(requestReference, productId, updateEmissionDraftDataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Emission Data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitEmissionData(requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionRequestProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitEmissionData(requestReference, productId, emissionRequestProductFormData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Un-locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unLockEmissionData(requestReference: string, productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unLockEmissionData(requestReference, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupplierEmissionControllerApi - factory interface
 * @export
 */
export const SupplierEmissionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierEmissionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Decline emission data request
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineEmissionRequest(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.declineEmissionRequest(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment(requestReference: string, productId: string, attachmentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadAttachment(requestReference, productId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get emissions data request product details
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProductDetails(requestReference: string, productId: string, options?: any): AxiosPromise<ProductEmissionDataRequestDetailsResponse> {
            return localVarFp.getEmissionRequestProductDetails(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get emission request products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionRequestProducts(options?: any): AxiosPromise<SupplierEmissionRequestProductResponse> {
            return localVarFp.getEmissionRequestProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Summary of Emission Requests received
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivedEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<EmissionRequestSummaryResponse> {
            return localVarFp.getReceivedEmissionRequests(pageNumber, limit, productRequestStatus, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEmissionData(requestReference: string, productId: string, options?: any): AxiosPromise<void> {
            return localVarFp.lockEmissionData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Auto-save interim emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistDraftEmissionData(requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options?: any): AxiosPromise<ProductEmissionDataRequestDetailsResponse> {
            return localVarFp.persistDraftEmissionData(requestReference, productId, updateEmissionDraftDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Emission Data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEmissionData(requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options?: any): AxiosPromise<EmissionRequestProduct> {
            return localVarFp.submitEmissionData(requestReference, productId, emissionRequestProductFormData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Un-locks emission form data
         * @param {string} requestReference 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unLockEmissionData(requestReference: string, productId: string, options?: any): AxiosPromise<void> {
            return localVarFp.unLockEmissionData(requestReference, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierEmissionControllerApi - object-oriented interface
 * @export
 * @class SupplierEmissionControllerApi
 * @extends {BaseAPI}
 */
export class SupplierEmissionControllerApi extends BaseAPI {
    /**
     * 
     * @summary Decline emission data request
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {EmissionDataRejectionRequest} emissionDataRejectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public declineEmissionRequest(requestReference: string, productId: string, emissionDataRejectionRequest: EmissionDataRejectionRequest, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).declineEmissionRequest(requestReference, productId, emissionDataRejectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download attachment
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public downloadAttachment(requestReference: string, productId: string, attachmentId: string, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).downloadAttachment(requestReference, productId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get emissions data request product details
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public getEmissionRequestProductDetails(requestReference: string, productId: string, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).getEmissionRequestProductDetails(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get emission request products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public getEmissionRequestProducts(options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).getEmissionRequestProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Summary of Emission Requests received
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>} [productRequestStatus] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public getReceivedEmissionRequests(pageNumber?: number, limit?: number, productRequestStatus?: ReadonlyArray<'NOT_STARTED' | 'REJECTED' | 'REQUESTED' | 'PENDING_REVIEW' | 'COMPLETED' | 'DECLINED' | 'CANCELED'>, sortDirection?: 'ASC' | 'DESC', options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).getReceivedEmissionRequests(pageNumber, limit, productRequestStatus, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Locks emission form data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public lockEmissionData(requestReference: string, productId: string, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).lockEmissionData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Auto-save interim emission form data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {UpdateEmissionDraftDataRequest} updateEmissionDraftDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public persistDraftEmissionData(requestReference: string, productId: string, updateEmissionDraftDataRequest: UpdateEmissionDraftDataRequest, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).persistDraftEmissionData(requestReference, productId, updateEmissionDraftDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Emission Data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {EmissionRequestProductFormData} emissionRequestProductFormData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public submitEmissionData(requestReference: string, productId: string, emissionRequestProductFormData: EmissionRequestProductFormData, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).submitEmissionData(requestReference, productId, emissionRequestProductFormData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Un-locks emission form data
     * @param {string} requestReference 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionControllerApi
     */
    public unLockEmissionData(requestReference: string, productId: string, options?: any) {
        return SupplierEmissionControllerApiFp(this.configuration).unLockEmissionData(requestReference, productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupplierEmissionsDataRequestControllerApi - axios parameter creator
 * @export
 */
export const SupplierEmissionsDataRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get EmissionsDataRequest by Id
         * @param {string} requestReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionsDataRequest: async (requestReference: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestReference' is not null or undefined
            assertParamExists('getEmissionsDataRequest', 'requestReference', requestReference)
            const localVarPath = `/api/supplier/emission-requests/{requestReference}`
                .replace(`{${"requestReference"}}`, encodeURIComponent(String(requestReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierEmissionsDataRequestControllerApi - functional programming interface
 * @export
 */
export const SupplierEmissionsDataRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierEmissionsDataRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get EmissionsDataRequest by Id
         * @param {string} requestReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmissionsDataRequest(requestReference: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionsDataRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmissionsDataRequest(requestReference, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupplierEmissionsDataRequestControllerApi - factory interface
 * @export
 */
export const SupplierEmissionsDataRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierEmissionsDataRequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get EmissionsDataRequest by Id
         * @param {string} requestReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmissionsDataRequest(requestReference: string, options?: any): AxiosPromise<EmissionsDataRequestResponse> {
            return localVarFp.getEmissionsDataRequest(requestReference, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierEmissionsDataRequestControllerApi - object-oriented interface
 * @export
 * @class SupplierEmissionsDataRequestControllerApi
 * @extends {BaseAPI}
 */
export class SupplierEmissionsDataRequestControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get EmissionsDataRequest by Id
     * @param {string} requestReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierEmissionsDataRequestControllerApi
     */
    public getEmissionsDataRequest(requestReference: string, options?: any) {
        return SupplierEmissionsDataRequestControllerApiFp(this.configuration).getEmissionsDataRequest(requestReference, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TemplateControllerApi - axios parameter creator
 * @export
 */
export const TemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Template
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (templateCreateRequest: TemplateCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateCreateRequest' is not null or undefined
            assertParamExists('createTemplate', 'templateCreateRequest', templateCreateRequest)
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Template from Product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromProduct: async (productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('createTemplateFromProduct', 'productId', productId)
            const localVarPath = `/api/templates/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Deprecated) Delete template and its form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: async (templateId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTemplate', 'templateId', templateId)
            const localVarPath = `/api/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete templates and their form data by Id
         * @param {ReadonlyArray<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplates: async (requestBody: ReadonlyArray<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteTemplates', 'requestBody', requestBody)
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads template data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllTemplates: async (fileName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/templates/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} templateId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplateAttachment: async (templateId: string, attachmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('downloadTemplateAttachment', 'templateId', templateId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadTemplateAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/templates/{templateId}/attachments/{attachmentId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get template form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDetails: async (templateId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTemplateDetails', 'templateId', templateId)
            const localVarPath = `/api/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import templates from file
         * @param {any} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTemplates: async (file: any, allowWarnings?: boolean, dryRun?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importTemplates', 'file', file)
            const localVarPath = `/api/templates/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (allowWarnings !== undefined) {
                localVarQueryParameter['allowWarnings'] = allowWarnings;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Templates
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [productName] 
         * @param {string} [productInternalReference] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {'UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (pageNumber?: number, limit?: number, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (productInternalReference !== undefined) {
                localVarQueryParameter['productInternalReference'] = productInternalReference;
            }

            if (emissionValueFrom !== undefined) {
                localVarQueryParameter['emissionValueFrom'] = emissionValueFrom;
            }

            if (emissionValueTo !== undefined) {
                localVarQueryParameter['emissionValueTo'] = emissionValueTo;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = (lastUpdatedFrom as any instanceof Date) ?
                    (lastUpdatedFrom as any).toISOString() :
                    lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = (lastUpdatedTo as any instanceof Date) ?
                    (lastUpdatedTo as any).toISOString() :
                    lastUpdatedTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Template
         * @param {string} templateId 
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {boolean} [updateEmissionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: async (templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTemplate', 'templateId', templateId)
            // verify required parameter 'templateCreateRequest' is not null or undefined
            assertParamExists('updateTemplate', 'templateCreateRequest', templateCreateRequest)
            const localVarPath = `/api/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (updateEmissionData !== undefined) {
                localVarQueryParameter['updateEmissionData'] = updateEmissionData;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateControllerApi - functional programming interface
 * @export
 */
export const TemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Template
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(templateCreateRequest: TemplateCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(templateCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Template from Product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplateFromProduct(productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplateFromProduct(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary (Deprecated) Delete template and its form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplate(templateId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete templates and their form data by Id
         * @param {ReadonlyArray<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplates(requestBody: ReadonlyArray<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplates(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads template data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllTemplates(fileName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllTemplates(fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} templateId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTemplateAttachment(templateId: string, attachmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTemplateAttachment(templateId, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get template form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateDetails(templateId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateDetails(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Import templates from file
         * @param {any} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTemplates(file: any, allowWarnings?: boolean, dryRun?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importTemplates(file, allowWarnings, dryRun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List Templates
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [productName] 
         * @param {string} [productInternalReference] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {'UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(pageNumber?: number, limit?: number, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(pageNumber, limit, productName, productInternalReference, emissionValueFrom, emissionValueTo, lastUpdatedFrom, lastUpdatedTo, sortBy, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Template
         * @param {string} templateId 
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {boolean} [updateEmissionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate(templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate(templateId, templateCreateRequest, updateEmissionData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateControllerApi - factory interface
 * @export
 */
export const TemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Template
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(templateCreateRequest: TemplateCreateRequest, options?: any): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.createTemplate(templateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Template from Product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromProduct(productId: string, options?: any): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.createTemplateFromProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Deprecated) Delete template and its form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate(templateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete templates and their form data by Id
         * @param {ReadonlyArray<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplates(requestBody: ReadonlyArray<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTemplates(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads template data
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllTemplates(fileName?: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadAllTemplates(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download attachment
         * @param {string} templateId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplateAttachment(templateId: string, attachmentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadTemplateAttachment(templateId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get template form data by Id
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDetails(templateId: string, options?: any): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.getTemplateDetails(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import templates from file
         * @param {any} file 
         * @param {boolean} [allowWarnings] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTemplates(file: any, allowWarnings?: boolean, dryRun?: boolean, options?: any): AxiosPromise<TemplateImportResponse> {
            return localVarFp.importTemplates(file, allowWarnings, dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Templates
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {string} [productName] 
         * @param {string} [productInternalReference] 
         * @param {number} [emissionValueFrom] 
         * @param {number} [emissionValueTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {'UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(pageNumber?: number, limit?: number, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any): AxiosPromise<TemplateListResponse> {
            return localVarFp.listTemplates(pageNumber, limit, productName, productInternalReference, emissionValueFrom, emissionValueTo, lastUpdatedFrom, lastUpdatedTo, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Template
         * @param {string} templateId 
         * @param {TemplateCreateRequest} templateCreateRequest 
         * @param {boolean} [updateEmissionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate(templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options?: any): AxiosPromise<TemplateDetailsResponse> {
            return localVarFp.updateTemplate(templateId, templateCreateRequest, updateEmissionData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateControllerApi - object-oriented interface
 * @export
 * @class TemplateControllerApi
 * @extends {BaseAPI}
 */
export class TemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create Template
     * @param {TemplateCreateRequest} templateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public createTemplate(templateCreateRequest: TemplateCreateRequest, options?: any) {
        return TemplateControllerApiFp(this.configuration).createTemplate(templateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Template from Product
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public createTemplateFromProduct(productId: string, options?: any) {
        return TemplateControllerApiFp(this.configuration).createTemplateFromProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Deprecated) Delete template and its form data by Id
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public deleteTemplate(templateId: string, options?: any) {
        return TemplateControllerApiFp(this.configuration).deleteTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete templates and their form data by Id
     * @param {ReadonlyArray<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public deleteTemplates(requestBody: ReadonlyArray<string>, options?: any) {
        return TemplateControllerApiFp(this.configuration).deleteTemplates(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads template data
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public downloadAllTemplates(fileName?: string, options?: any) {
        return TemplateControllerApiFp(this.configuration).downloadAllTemplates(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download attachment
     * @param {string} templateId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public downloadTemplateAttachment(templateId: string, attachmentId: string, options?: any) {
        return TemplateControllerApiFp(this.configuration).downloadTemplateAttachment(templateId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get template form data by Id
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public getTemplateDetails(templateId: string, options?: any) {
        return TemplateControllerApiFp(this.configuration).getTemplateDetails(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import templates from file
     * @param {any} file 
     * @param {boolean} [allowWarnings] 
     * @param {boolean} [dryRun] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public importTemplates(file: any, allowWarnings?: boolean, dryRun?: boolean, options?: any) {
        return TemplateControllerApiFp(this.configuration).importTemplates(file, allowWarnings, dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Templates
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {string} [productName] 
     * @param {string} [productInternalReference] 
     * @param {number} [emissionValueFrom] 
     * @param {number} [emissionValueTo] 
     * @param {string} [lastUpdatedFrom] 
     * @param {string} [lastUpdatedTo] 
     * @param {'UPDATED_AT' | 'EMISSION_VALUE'} [sortBy] 
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public listTemplates(pageNumber?: number, limit?: number, productName?: string, productInternalReference?: string, emissionValueFrom?: number, emissionValueTo?: number, lastUpdatedFrom?: string, lastUpdatedTo?: string, sortBy?: 'UPDATED_AT' | 'EMISSION_VALUE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return TemplateControllerApiFp(this.configuration).listTemplates(pageNumber, limit, productName, productInternalReference, emissionValueFrom, emissionValueTo, lastUpdatedFrom, lastUpdatedTo, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Template
     * @param {string} templateId 
     * @param {TemplateCreateRequest} templateCreateRequest 
     * @param {boolean} [updateEmissionData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateControllerApi
     */
    public updateTemplate(templateId: string, templateCreateRequest: TemplateCreateRequest, updateEmissionData?: boolean, options?: any) {
        return TemplateControllerApiFp(this.configuration).updateTemplate(templateId, templateCreateRequest, updateEmissionData, options).then((request) => request(this.axios, this.basePath));
    }
}


